import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Form, Modal } from 'react-bootstrap';
import OtpInput from 'react-otp-input';
import EmailClassificationRules from "../../components/EmailClassificationRules";
import AccountProjectModal from "../../components/AccountProjectModal";
import CalendarSyncSettings from "../../components/CalendarSyncSettings";
import TodoistSyncSettings from "../../components/TodoistSyncSettings";
import EmailForwardSettings from "../../components/EmailForwardSettings";
import TeamsSyncSettings from "../../components/TeamsSyncSettings";
import { listTeamsAccounts } from "../../helper/teamsApi";
import { teamsSettingsRowState } from "../../utils/teams/teamsSettingsModel";
import { callAPI } from "../../helper/apiUtils";
import { getBadgeCount, invalidateBadgeCount } from "../../helper/badgeCount";
import { useHistory, withRouter } from "react-router-dom";
import { $user } from "../../helper/UserFactory";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { FR } from "../../Languages/FR";
import { IT } from "../../Languages/IT";
import { ES } from "../../Languages/ES";
import { PT } from "../../Languages/PT";
import { RU } from "../../Languages/RU";
import { PL } from "../../Languages/PL";
import { NL } from "../../Languages/NL";
import { TR } from "../../Languages/TR";
import { EL } from "../../Languages/EL";
import { CS } from "../../Languages/CS";
import { HU } from "../../Languages/HU";
import { RO } from "../../Languages/RO";
import { BG } from "../../Languages/BG";
import { HR } from "../../Languages/HR";
import { SL } from "../../Languages/SL";
import { SK } from "../../Languages/SK";
import { SV } from "../../Languages/SV";
import { NO } from "../../Languages/NO";
import { DA } from "../../Languages/DA";
import { FI } from "../../Languages/FI";
import { ZH } from "../../Languages/ZH";
import { HI } from "../../Languages/HI";
import { AR } from "../../Languages/AR";
import { JA } from "../../Languages/JA";
import { KO } from "../../Languages/KO";
import { VI } from "../../Languages/VI";
import { ID } from "../../Languages/ID";
import { MS } from "../../Languages/MS";
import { BN } from "../../Languages/BN";
import { TA } from "../../Languages/TA";
import { TE } from "../../Languages/TE";
import { MR } from "../../Languages/MR";
import { $crud } from "../../helper/CrudFactory";
import { applyImapHostHint, imapFormFromAccount } from "../../helper/imapDomainHints";
import { LANGUAGE, SET_AUTO_TRANSLATION, SET_AUTO_TRANSLATION_LANGUAGES, SET_TRANSLATE_ROOM_AND_GROUP_NAMES, SET_USER, CLEAR_CACHED_MESSAGES, SET_EMAIL_ACCOUNTS, EMAIL_ACCOUNTS_CHANGED, ALL_BADGE_COUNT, RESET_UNSEEN_EMAIL_COUNT } from "../../store";
import { connect, useDispatch, useSelector } from "react-redux";
import { clearTranslationCache } from "../../utils/translationUtils";
import {
    normalizeAutoTranslationLanguages,
    resolveAutoTranslationSelection,
    selectionToApiPayload,
} from "../../utils/autoTranslationLanguages";
import { persistStartupScreen, resolveStartupScreen, SELECTABLE_STARTUP_SCREENS } from "../../utils/startupScreen";
import { resolvePackageId, resolvePackageLabel } from "../../utils/packageTheme";
import featureFlags from "../../featureFlags";
import { version } from '../../../package.json';
import { BASE_URL } from '../../helper/constants';
import NotificationSettings from '../../components/NotificationSettings';
import TwoFactorSettingsPanel from '../../components/TwoFactorSettingsPanel';
import { LoadingDots } from '../../LoadingDots/LoadingDots';
import ApiLoaderOverlay from '../../components/ApiLoaderOverlay';
import { SettingsBanner, SettingsNote, SettingsRow, SettingsSection, SettingsStack, SettingsTag } from '../../components/settings/SettingsList';
import { saveWorkspacePreferences } from '../../components/KjuupIoSetupModal';
import { fetchAndStoreSubscriptionStatus } from '../../services/PaymentService';
import { twoFactorRequest } from '../../helper/twoFactorApi';
import { convertBranchRole, convertPosition } from '../../helper/convertor';
import { openCockpit, openCompanyAdmin, openCompanyDocuments, openMyCompanies } from '../Cockpit/cockpitNavigation';
import { recommendKjuup } from '../../utils/recommendKjuup';
import { confirmAndLogout } from '../../utils/logoutUser';
import { canShowEmailCalendarIntegration } from '../../utils/kjuupIoEntitlement';
import { resolveStripeFlags } from '../../utils/stripeFeature';
import {
    companyTrialEndedAskBody,
    navigateToKjuupIoBilling,
    shouldShowCompanyTrialEndedNote,
} from '../../utils/kjuupIoBillingNav';
import "./ProfileSetting.css";

// Supported languages list (34 languages) - same as login page
const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'gsw', name: 'Swiss German', nativeName: 'Schweizerdeutsch', searchTerms: 'swiss german schwiizerdütsch alemannic' },
  { code: 'wae', name: 'Valais German', nativeName: 'Walliserdeutsch', searchTerms: 'valais wallis wallisertitsch' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe' },
  { code: 'el', name: 'Greek', nativeName: 'Ελληνικά' },
  { code: 'cs', name: 'Czech', nativeName: 'Čeština' },
  { code: 'hu', name: 'Hungarian', nativeName: 'Magyar' },
  { code: 'ro', name: 'Romanian', nativeName: 'Română' },
  { code: 'bg', name: 'Bulgarian', nativeName: 'Български' },
  { code: 'hr', name: 'Croatian', nativeName: 'Hrvatski' },
  { code: 'sl', name: 'Slovenian', nativeName: 'Slovenščina (Slovenian)' },
  { code: 'sk', name: 'Slovak', nativeName: 'Slovenčina (Slovak)' },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska' },
  { code: 'no', name: 'Norwegian', nativeName: 'Norsk' },
  { code: 'da', name: 'Danish', nativeName: 'Dansk' },
  { code: 'fi', name: 'Finnish', nativeName: 'Suomi' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'ko', name: 'Korean', nativeName: '한국어' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  { code: 'ms', name: 'Malay', nativeName: 'Bahasa Melayu' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
];

const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map(lang => lang.code);

const ALL_LANG_STRINGS = [DE, EN, FR, IT, ES, PT, RU, PL, NL, TR, EL, CS, HU, RO, BG, HR, SL, SK, SV, NO, DA, FI, ZH, HI, AR, JA, KO, VI, ID, MS, BN, TA, TE, MR];
const ALL_DEFAULT_MESSAGES = new Set(
    ALL_LANG_STRINGS.map(l => l.unavailability_default_message).filter(Boolean)
);
function isDefaultUnavailMessage(msg) {
    if (!msg) return false;
    const trimmed = msg.trim();
    return ALL_DEFAULT_MESSAGES.has(trimmed);
}

// Username/password registration used to store a placeholder email
// (e.g. username@user.com). Do not show those as a real notification address.
const GENERATED_EMAIL_DOMAINS = ['@kjuup-user.com', '@user.com'];

function isGeneratedNotificationEmail(email) {
    if (!email || typeof email !== 'string') return false;
    const normalized = email.trim().toLowerCase();
    return GENERATED_EMAIL_DOMAINS.some((domain) => normalized.endsWith(domain));
}

const BRIEFING_HOURS = Array.from({ length: 24 }, (_, h) => h);
// Model that writes the daily report: self-hosted ("internal") or Mistral ("external").
const BRIEFING_MODELS = ['internal', 'external'];
const normalizeBriefingModel = (value) => (value === 'external' ? 'external' : 'internal');
const DEFAULT_BRIEFING_HOUR = 18;

function normalizeBriefingHour(value) {
    const n = parseInt(value, 10);
    if (!Number.isFinite(n) || n < 0 || n > 23) return DEFAULT_BRIEFING_HOUR;
    return n;
}

function formatBriefingHour(value) {
    return `${String(normalizeBriefingHour(value)).padStart(2, '0')}:00`;
}

// Sub-pages of the personal settings (the mobile app's stack screens), kept in ?section=.
const SETTINGS_SECTIONS = ['notifications', 'unavailability', 'twofa', 'email-accounts', 'email-forward', 'calendar-sync', 'todoist-sync', 'teams'];
// Kjuup.io sub-pages: greyed out without an active plan; a click opens the Kjuup.io offer.
// Microsoft Teams ('teams') is gated on its own: it stays open without the plan while a Teams
// account or archive exists, so the imported chats can always be disconnected and deleted.
const IO_SECTIONS = new Set(['email-accounts', 'email-forward', 'calendar-sync', 'todoist-sync']);
// Message languages for automatic translation (Swiss and Valais German count as German).
const TRANSLATION_LANGUAGES = SUPPORTED_LANGUAGES.filter((lang) => lang.code !== 'gsw' && lang.code !== 'wae');

/** `{{name}}` placeholders filled from vars. */
function fillStr(text, vars) {
    return String(text == null ? '' : text).replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => (vars && vars[k] != null ? String(vars[k]) : m));
}

/** "2026-10-20" → "20.10.2026", as the mobile app shows dates. */
function formatDisplayDate(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
}

function initialsOf(name) {
    const parts = String(name || '').replace(/^@/, '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '';
    const first = parts[0][0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
}

/** The company admins of a Kjuup+ company assign its Kjuup.io seats (Cockpit / mobile rule). */
function viewerAssignsCompanySeats(company) {
    if (!company || !company.isKjuup || company.stripeFeatureEnabled === false) return false;
    if (company.isSuperAdmin || company.role === 'ROLE_COMPANY_SUPER_ADMIN') return true;
    return String(company.position || '').trim().toLowerCase() === 'company admin';
}

/** Round avatar: the photo over the initials (the initials stay when the photo fails). */
function SettingsAvatar({ src, name, size = 'md', ring = false }) {
    const [failed, setFailed] = useState(false);
    useEffect(() => setFailed(false), [src]);
    return (
        <span className={`ps-avatar ps-avatar--${size}${ring ? ' ps-avatar--ring' : ''}`} aria-hidden="true">
            <span className="ps-avatar__inner">
                <span className="ps-avatar__initials">{initialsOf(name)}</span>
                {src && !failed ? <img className="ps-avatar__img" src={src} alt="" onError={() => setFailed(true)} /> : null}
            </span>
        </span>
    );
}

/** Centred dialog in place of the mobile app's bottom sheets. */
function SettingsDialog({ show, onHide, title, subtitle, children, footer, closeLabel, className = '' }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            dialogClassName={`ps-dialog${className ? ` ${className}` : ''}`}
            contentClassName="ps-dialog__content"
        >
            <div className="ps-dialog__header">
                <div className="ps-dialog__titles">
                    <h4 className="ps-dialog__title">{title}</h4>
                    {subtitle ? <p className="ps-dialog__subtitle">{subtitle}</p> : null}
                </div>
                <button type="button" className="kj-btn kj-btn--icon kj-btn--neutral ps-dialog__close" onClick={onHide} aria-label={closeLabel}>
                    <span className="material-symbols-outlined">close</span>
                </button>
            </div>
            <div className="ps-dialog__body">{children}</div>
            {footer ? <div className="ps-dialog__footer">{footer}</div> : null}
        </Modal>
    );
}

/** One row of a choice list: label (+ sub), the round pick mark (square for several picks). */
function ChoiceRow({ label, sub, selected, onClick, multi = false, leading = null, scrollIntoViewWhenSelected = false }) {
    const ref = useRef(null);
    useEffect(() => {
        if (scrollIntoViewWhenSelected && selected && ref.current && ref.current.scrollIntoView) {
            ref.current.scrollIntoView({ block: 'center' });
        }
        // Only when the list opens with this row picked.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <button
            type="button"
            ref={ref}
            className={`ps-choice${selected ? ' is-selected' : ''}`}
            role={multi ? 'checkbox' : 'radio'}
            aria-checked={!!selected}
            onClick={onClick}
        >
            {leading}
            <span className="ps-choice__text">
                <span className="ps-choice__label">{label}</span>
                {sub ? <span className="ps-choice__sub">{sub}</span> : null}
            </span>
            <span className={`ps-pick${selected ? ' is-on' : ''}${multi ? ' is-square' : ''}`} aria-hidden="true">
                {selected ? <span className="material-symbols-outlined">check</span> : null}
            </span>
        </button>
    );
}

/** Search field (settings header, language and replacement lists). */
function SearchField({ value, onChange, placeholder, clearLabel, autoFocus = false, className = '' }) {
    return (
        <div className={`ps-search${className ? ` ${className}` : ''}`}>
            <span className="material-symbols-outlined ps-search__icon" aria-hidden="true">search</span>
            <input
                type="text"
                className="ps-search__input"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                aria-label={placeholder}
                autoFocus={autoFocus}
                autoComplete="off"
            />
            {value ? (
                <button type="button" className="kj-btn kj-btn--icon kj-btn--sm kj-btn--neutral ps-search__clear" onClick={() => onChange('')} aria-label={clearLabel}>
                    <span className="material-symbols-outlined">close</span>
                </button>
            ) : null}
        </div>
    );
}

/** Password field with its show / hide button (mobile PasswordSheetPro). */
function PasswordField({ id, label, value, onChange, visible, onToggle, toggleLabel }) {
    return (
        <div className="ps-field">
            <label className="ps-field__label" htmlFor={id}>{label}</label>
            <div className="ps-input">
                <span className="material-symbols-outlined" aria-hidden="true">lock</span>
                <input
                    id={id}
                    type={visible ? 'text' : 'password'}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    autoComplete="new-password"
                />
                <button
                    type="button"
                    className="kj-btn kj-btn--icon kj-btn--neutral ps-input__eye"
                    onClick={onToggle}
                    aria-label={toggleLabel}
                    aria-pressed={!!visible}
                >
                    <span className="material-symbols-outlined">{visible ? 'visibility_off' : 'visibility'}</span>
                </button>
            </div>
        </div>
    );
}

/** Date tile (mobile unavailability): label and the date; the whole tile opens the date picker. */
function DateTile({ id, icon, label, value, min, onChange }) {
    const shown = formatDisplayDate(value);
    return (
        <label className="ps-date-tile" htmlFor={id}>
            <span className="ps-date-tile__head">
                <span className="material-symbols-outlined" aria-hidden="true">{icon}</span>
                <span className="ps-date-tile__label">{label}</span>
            </span>
            <span className={`ps-date-tile__value${shown ? '' : ' is-empty'}`}>{shown || '–'}</span>
            <input
                id={id}
                type="date"
                className="ps-date-tile__input"
                value={value || ''}
                min={min || undefined}
                onChange={(e) => onChange(e.target.value)}
            />
        </label>
    );
}

function syncSignaturesToLocalStorage(accounts) {
    try {
        const existing = JSON.parse(localStorage.getItem('emailSignatures') || '{}');
        for (const acc of accounts) {
            const id = acc.id || acc._id;
            if (acc.emailSignature) existing[id] = acc.emailSignature;
        }
        localStorage.setItem('emailSignatures', JSON.stringify(existing));
    } catch { /* ignore */ }
}

function EmailSignatureEditor({ accountId, initialSignature, strings, onSaved }) {
    const [expanded, setExpanded] = useState(false);
    const [value, setValue] = useState(() => {
        if (initialSignature) return initialSignature;
        try {
            const sigs = JSON.parse(localStorage.getItem('emailSignatures') || '{}');
            return sigs[accountId] || '';
        } catch { return ''; }
    });
    const [saved, setSaved] = useState(true);
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        setSaving(true);
        try {
            const { data } = await callAPI(`/email/accounts/${accountId}/signature`, {}, 'PUT', { signature: value });
            if (data?.status === false) {
                console.error('Failed to save signature:', data?.message);
                setSaving(false);
                return;
            }
            // Keep localStorage in sync for compose components
            try {
                const sigs = JSON.parse(localStorage.getItem('emailSignatures') || '{}');
                if (value.trim()) {
                    sigs[accountId] = value;
                } else {
                    delete sigs[accountId];
                }
                localStorage.setItem('emailSignatures', JSON.stringify(sigs));
            } catch { /* ignore */ }
            setSaved(true);
            setExpanded(false);
            if (onSaved) onSaved(accountId, value);
        } catch (err) {
            console.error('Save signature error:', err);
        }
        setSaving(false);
    };

    const hasSignature = value.trim().length > 0;

    return (
        <div className="email-signature-editor">
            <button
                type="button"
                className="kj-btn kj-btn--ghost kj-btn--neutral kj-btn--email email-signature-toggle"
                onClick={() => setExpanded((v) => !v)}
            >
                <span className="material-symbols-outlined profile-setting__sig-icon">
                    draw
                </span>
                <span>{strings.email_signature || 'Signature'}</span>
                {hasSignature && !expanded && (
                    <span className="email-signature-badge">✓</span>
                )}
                <span className="material-symbols-outlined profile-setting__sig-caret">
                    {expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                </span>
            </button>
            {expanded && (
                <div className="email-signature-body">
                    <textarea
                        data-testid={`accountSignatureField-${accountId}`}
                        className="email-signature-textarea"
                        value={value}
                        onChange={(e) => { setValue(e.target.value); setSaved(false); }}
                        placeholder={strings.email_signature_placeholder || 'Enter your email signature...'}
                        rows={4}
                    />
                    <div className="email-signature-actions">
                        <button
                            data-testid={`accountSignatureSave-${accountId}`}
                            type="button"
                            className="kj-btn kj-btn--outline kj-btn--email kj-btn--sm kj-btn--pill"
                            onClick={handleSave}
                            disabled={saved || saving}
                        >
                            {saving
                                ? (strings.email_signature_saving || 'Saving...')
                                : saved
                                    ? (strings.email_signature_saved || 'Saved')
                                    : (strings.email_signature_save || 'Save')}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

function ProfileSetting(props) {
    const history = useHistory();
    const [autoTransLangSelection, setAutoTransLangSelection] = useState([]);
    const autoTransSaveSeqRef = useRef(0);
    const [viewPassword, setViewPassword] = useState(false);
    const [viewPasswordConfirm, setViewPasswordConfirm] = useState(false);

    const dispatch = useDispatch();
    // Short choices open as dialogs (the mobile sheets); sub-pages are ?section= views.
    const [dialog, setDialog] = useState(null)
    const [section, setSection] = useState(null)
    const [langPick, setLangPick] = useState(null)
    const [langQuery, setLangQuery] = useState('')
    const [replacementQuery, setReplacementQuery] = useState('')
    const [twoFactorOn, setTwoFactorOn] = useState(null)
    const [myCompanies, setMyCompanies] = useState([])
    const [workspaceSaving, setWorkspaceSaving] = useState(false)
    const workspaceSavingRef = useRef(false)
    const [transLangSaving, setTransLangSaving] = useState(false)
    const scrollRef = useRef(null)
    const listScrollTopRef = useRef(0)
    const [focusRow, setFocusRow] = useState(null)
    const [viewLoader, setViewLoader] = useState(false)
    const [email, setEmail] = useState('')
    const [isEditingEmail, setIsEditingEmail] = useState(false)
    const [emailSentNote, setEmailSentNote] = useState('')
    const [errors, setErrors] = useState({

    });
    const [passwordParam, setPasswordParam] = useState({
        "password": "",
        "confirmPassword": ""
    })
    const user = $user.get();
    const userN = useSelector((state) => state.user);
    const storedNotificationEmail = userN?.email || user?.email || '';
    const hasRealNotificationEmail = !!storedNotificationEmail && !isGeneratedNotificationEmail(storedNotificationEmail);
    const activityMessages = useSelector((state) => state.activityMessages);
    const emailAccountsChangedAt = useSelector((state) => state.emailAccountsChangedAt);
    const profile = useSelector((state) => state.profile);
    const subscriptionState = useSelector((state) => state.subscription) || {};
    const {
        stripeFeatureEnabled,
        companyStripeFeatureEnabled,
        isKjuupPlusMember,
        stripeUiEnabled,
    } = resolveStripeFlags(profile, subscriptionState);
    const hasActiveKjuupIoPlan = !stripeUiEnabled || !!subscriptionState.active;
    const hasUsedTrial = !!subscriptionState.hasUsedTrial;
    const showCompanyTrialEndedNote =
        shouldShowCompanyTrialEndedNote(subscriptionState);
    // Personal Stripe UI, or Kjuup+ only when seat active / admin trial-ended note.
    // Kjuup+ with no subscription at all: hide all Kjuup.io entry points.
    const showKjuupIoUpsellUi =
        !!stripeUiEnabled &&
        (!isKjuupPlusMember || hasActiveKjuupIoPlan || showCompanyTrialEndedNote);
    // Stripe-gated email/calendar; hidden when Stripe is disabled for this user.
    const emailCalendarAllowed = canShowEmailCalendarIntegration({
        isKjuupPlusMember,
        hasActiveKjuupIoPlan,
        showCompanyTrialEndedNote,
        stripeFeatureEnabled,
        companyStripeFeatureEnabled,
    });
    // Kjuup and Kjuup+ without a Kjuup.io subscription still see the Kjuup.io
    // settings, but greyed out. A click opens the Kjuup.io offer on the cockpit.
    const ioSettingsLocked = !!stripeUiEnabled && !subscriptionState.active;
    const showIoSettings = emailCalendarAllowed || ioSettingsLocked;
    // Same Kjuup.io / Stripe gate as Email Accounts — do not hide Calendar Sync
    // just because the app is pointed at production.
    const showCalendarSyncSettings = showIoSettings;
    const openCockpitIoOffer = () => {
        history.push({ pathname: "/", search: `?section=kjuup-io&focus=${Date.now()}` });
    };
    const [username, setusername] = useState(user?.username)
    const [otp, setOtp] = useState('')
    const [cotp, setCOtp] = useState('')
    const [pinLoading, setPinLoading] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [invalidMsg, setInvalidMsg] = useState('')
    const [emailAccounts, setEmailAccounts] = useState([])
    const [emailAccountsLoading, setEmailAccountsLoading] = useState(false)
    const [connectingProvider, setConnectingProvider] = useState(null)
    const [imapForm, setImapForm] = useState({
        user: '',
        password: '',
        host: '',
        port: '993',
        tls: true,
        smtpHost: '',
        smtpPort: '587',
        smtpSecure: false,
    })
    const [imapConnecting, setImapConnecting] = useState(false)
    const [showImapPassword, setShowImapPassword] = useState(false)
    const [showImapModal, setShowImapModal] = useState(false)
    const [showImapManual, setShowImapManual] = useState(false)
    const [imapError, setImapError] = useState('')
    // When set, the IMAP modal is editing/reconnecting an existing account
    // (email prefilled); null means connecting a brand-new IMAP account.
    const [editingImapAccount, setEditingImapAccount] = useState(null)
    const [disconnectingAccountId, setDisconnectingAccountId] = useState(null)
    // Which account currently has its "sync more months" 3/6 options expanded.
    // Collapsed by default (single button) to keep each account entry compact.
    const [expandedSyncAccountId, setExpandedSyncAccountId] = useState(null)
    // After connecting a new account we ask whether it belongs to one specific
    // project (see AccountProjectModal). `accountProjectPrompt` holds that new
    // account (or null); `promptBuildings` feeds the type-ahead picker.
    const [accountProjectPrompt, setAccountProjectPrompt] = useState(null)
    const [promptBuildings, setPromptBuildings] = useState([])
    // Company connections offered when creating a brand-new (external) room from
    // the AccountProjectModal; only asked for when there is more than one.
    const [promptCompanies, setPromptCompanies] = useState([])
    const [accountProjectBusy, setAccountProjectBusy] = useState(false)
    // Guards against firing the prefetches multiple times in parallel.
    const promptBuildingsLoading = useRef(false)
    const promptCompaniesLoading = useRef(false)

    const { isGerm, setIsGerm, language: contextLanguage, setLanguage: setContextLanguage, strings } = React.useContext(LanguageContext);

    // Unavailability note state
    const [unavailActive, setUnavailActive] = useState(false)
    const [unavailMessage, setUnavailMessage] = useState('')
    const [unavailStartDate, setUnavailStartDate] = useState('')
    const [unavailEndDate, setUnavailEndDate] = useState('')
    const [unavailLoading, setUnavailLoading] = useState(false)
    const [unavailSaving, setUnavailSaving] = useState(false)
    const [unavailReplacementUser, setUnavailReplacementUser] = useState('')
    const [unavailReplacementUserName, setUnavailReplacementUserName] = useState('')
    const [colleagues, setColleagues] = useState([])
    const [colleaguesLoading, setColleaguesLoading] = useState(false)
    // The replacement stored on the server (to know when "Keine Vertretung" must clear it).
    const savedReplacementRef = useRef('')
    const [isKjuupPlus, setIsKjuupPlus] = useState(false)
    const [syncingAccountId, setSyncingAccountId] = useState(null);
    // Use a function initializer so `&&` short-circuit doesn't trip rules-of-hooks.
    const [isEmailOn, setIsEmailOn] = useState(
        () => !!(userN?.emailNotification && userN?.emailVerified),
    );
    const [isArticleEmailOn, setIsArticleEmailOn] = useState(
        () => !!(userN?.articleEmailNotification && userN?.emailVerified),
    );
    const [isTodoNotifOn, setIsTodoNotifOn] = useState(() => !!userN?.todoNotificationEnabled);
    const [isEmailPushOn, setIsEmailPushOn] = useState(() => userN?.emailPushNotificationEnabled !== false);
    // Keep the toggle in lockstep with the shared user flag (profile fetch,
    // other-device socket). Same field the mobile app reads.
    useEffect(() => {
        setIsTodoNotifOn(!!userN?.todoNotificationEnabled);
    }, [userN?.todoNotificationEnabled]);
    useEffect(() => {
        setIsEmailPushOn(userN?.emailPushNotificationEnabled !== false);
    }, [userN?.emailPushNotificationEnabled]);
    const [startupScreen, setStartupScreen] = useState(() => resolveStartupScreen(userN?.startupScreen));
    const [startupScreenSaving, setStartupScreenSaving] = useState(false);
    // Asked once in the Kjuup.io setup. Afterwards the same switches live in the sidebar.
    const isKjuupIoPackage = resolvePackageId(profile, subscriptionState) === "io";
    const chatsEnabledPref = userN?.chatsEnabled !== false;
    const emailModePref = userN?.emailMode === "reports" ? "reports" : "client";
    const teamsModePref = userN?.teamsMode === "reports" ? "reports" : "client";
    // Kjuup.io: with chats hidden the Nachrichten entry is called "E-Mail"; with
    // the email client off as well the entry does not exist (reports are on the cockpit).
    const messagesEntryIsEmail = isKjuupIoPackage && !chatsEnabledPref;
    const messagesEntryHidden = messagesEntryIsEmail && emailModePref === "reports";
    const startupOptions = SELECTABLE_STARTUP_SCREENS.filter((s) => {
        if (s.value === "cockpit" && !featureFlags.enableCockpit) return false;
        if (s.value === "messages" && messagesEntryHidden) return false;
        return true;
    });
    const startupLabel = (s) => {
        if (!s) return "";
        if (s.value === "cockpit") return strings.startup_screen_cockpit || "Cockpit";
        if (s.value === "feed") return strings.nav_news || strings.startup_screen_feed || "News";
        if (s.value === "messages" && messagesEntryIsEmail) return strings.nav_email || "E-Mail";
        return strings[s.labelKey] || s.value;
    };
    const [translateNames, setTranslateNames] = useState(() => !!userN?.translateRoomAndGroupNames);
    const [translateNamesSaving, setTranslateNamesSaving] = useState(false);
    const [emailSummaryPreview, setEmailSummaryPreview] = useState(() => !!userN?.emailSummaryPreviewEnabled);
    const [emailSummaryPreviewSaving, setEmailSummaryPreviewSaving] = useState(false);
    const [briefingHour, setBriefingHour] = useState(() => normalizeBriefingHour(userN?.dailyBriefingHour));
    const [briefingHourSaving, setBriefingHourSaving] = useState(false);
    const [briefingModel, setBriefingModel] = useState(() => normalizeBriefingModel(userN?.briefingModelMode));
    const [briefingModelSaving, setBriefingModelSaving] = useState(false);
    // Mistral notice: opened from the ⓘ button (read only) or before switching to
    // the external model (with a confirm button).
    const [briefingInfoConfirm, setBriefingInfoConfirm] = useState(false);
    // Nightly project reports ("Aktueller Stand" in a project's Übersicht): own AI, or Mistral.
    const [projectReportModel, setProjectReportModel] = useState(() => normalizeBriefingModel(userN?.projectReportModelMode));
    const [projectReportSaving, setProjectReportSaving] = useState(false);
    const cardRef = useRef(null);

    useEffect(() => {
        setTranslateNames(!!userN?.translateRoomAndGroupNames);
    }, [userN?.translateRoomAndGroupNames]);
    useEffect(() => {
        setEmailSummaryPreview(!!userN?.emailSummaryPreviewEnabled);
    }, [userN?.emailSummaryPreviewEnabled]);
    useEffect(() => {
        setBriefingHour(normalizeBriefingHour(userN?.dailyBriefingHour));
    }, [userN?.dailyBriefingHour]);
    useEffect(() => {
        setBriefingModel(normalizeBriefingModel(userN?.briefingModelMode));
    }, [userN?.briefingModelMode]);
    useEffect(() => {
        setProjectReportModel(normalizeBriefingModel(userN?.projectReportModelMode));
    }, [userN?.projectReportModelMode]);

    useEffect(() => {
        fetchAndStoreSubscriptionStatus(dispatch);
    }, [dispatch]);

    // Poll the accounts list while any account is doing its initial sync so we
    // can hide the "Syncing account…" note as soon as lastSyncAt is set.
    // Depend on a boolean (not the full accounts array) so each poll response
    // doesn't tear down and recreate the interval.
    const isEmailAccountConnectionError = (account) =>
        account?.status === 'error' || account?.status === 'auth_error';

    const anyInitialSyncing = (emailAccounts || []).some((account) => {
        if (!account) return false;
        if (account.lastSyncAt) return false;
        if (isEmailAccountConnectionError(account)) return false;
        const createdAtRaw = account.createdAt;
        if (createdAtRaw) {
            const createdMs = new Date(createdAtRaw).getTime();
            if (!Number.isNaN(createdMs)) {
                const ageMs = Date.now() - createdMs;
                if (ageMs > 30 * 60 * 1000) return false;
            }
        }
        return true;
    });
    useEffect(() => {
        if (!anyInitialSyncing) return;
        const timer = setInterval(() => {
            // Silent: don't flash the skeleton / remount the section while syncing.
            fetchEmailAccounts({ silent: true });
        }, 4000);
        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [anyInitialSyncing]);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            setUnavailLoading(true);
            try {
                const { data } = await callAPI('/user/unavailability', {}, 'GET');
                if (cancelled) return;
                if (data.status && data.unavailability) {
                    setUnavailActive(true);
                    const loadedMsg = data.unavailability.message || '';
                    setUnavailMessage(isDefaultUnavailMessage(loadedMsg)
                        ? (strings.unavailability_default_message || loadedMsg)
                        : loadedMsg);
                    setUnavailStartDate(data.unavailability.startDate ? data.unavailability.startDate.slice(0, 10) : '');
                    setUnavailEndDate(data.unavailability.endDate ? data.unavailability.endDate.slice(0, 10) : '');
                    setUnavailReplacementUser(data.unavailability.replacementUserId || '');
                    savedReplacementRef.current = data.unavailability.replacementUserId || '';
                    setUnavailReplacementUserName(data.unavailability.replacementUserName || '');
                } else {
                    setUnavailActive(false);
                    setUnavailMessage(strings.unavailability_default_message || '');
                    setUnavailStartDate(new Date().toISOString().slice(0, 10));
                    setUnavailEndDate('');
                    setUnavailReplacementUser('');
                    setUnavailReplacementUserName('');
                }
            } catch (e) {
                console.error('Failed to load unavailability:', e);
            } finally {
                if (!cancelled) setUnavailLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        setUnavailMessage(prev =>
            isDefaultUnavailMessage(prev)
                ? (strings.unavailability_default_message || prev)
                : prev
        );
    }, [strings]);

    useEffect(() => {
        (async () => {
            setColleaguesLoading(true);
            try {
                const { data } = await callAPI('/user/colleagues', {}, 'GET');
                if (data.status) {
                    setColleagues(data.colleagues || []);
                    setIsKjuupPlus(!!data.isKjuupPlus);
                }
            } catch (e) {
                console.error('Failed to load colleagues:', e);
            } finally {
                setColleaguesLoading(false);
            }
        })();
    }, []);

    const handleUnavailSave = async () => {
        if (!unavailEndDate) {
            $crud.notify({ type: 'error', message: strings.unavailability_end_date_required });
            return;
        }
        setUnavailSaving(true);
        try {
            // PUT /user/unavailability only writes a replacement it is given, so it can't
            // remove one. To clear it, end the saved note first; the PUT then creates a
            // fresh note without a replacement. (Drop this once the backend accepts null.)
            if (!unavailReplacementUser && savedReplacementRef.current && unavailActive) {
                const { data: removed } = await callAPI('/user/unavailability', {}, 'DELETE');
                if (removed && removed.status) setUnavailActive(false);
            }
            const { data } = await callAPI('/user/unavailability', {}, 'PUT', {
                message: unavailMessage,
                startDate: unavailStartDate,
                endDate: unavailEndDate,
                isActive: true,
                replacementUser: unavailReplacementUser || undefined,
            });
            if (data.status) {
                setUnavailActive(true);
                savedReplacementRef.current = unavailReplacementUser || '';
                $crud.notify({ type: 'success', message: strings.unavailability_saved });
            } else {
                $crud.notify({ type: 'error', message: data.message || strings.unavailability_save_error });
            }
        } catch (e) {
            console.error('Failed to save unavailability:', e);
            $crud.notify({ type: 'error', message: strings.unavailability_save_error });
        } finally {
            setUnavailSaving(false);
        }
    };

    const handleUnavailDeactivate = async () => {
        setUnavailSaving(true);
        try {
            const { data } = await callAPI('/user/unavailability', {}, 'DELETE');
            if (data.status) {
                setUnavailActive(false);
                setUnavailMessage(strings.unavailability_default_message || '');
                setUnavailStartDate(new Date().toISOString().slice(0, 10));
                setUnavailEndDate('');
                setUnavailReplacementUser('');
                setUnavailReplacementUserName('');
                savedReplacementRef.current = '';
                $crud.notify({ type: 'success', message: strings.unavailability_deactivated });
            } else {
                $crud.notify({ type: 'error', message: data.message || strings.unavailability_save_error });
            }
        } catch (e) {
            console.error('Failed to deactivate unavailability:', e);
            $crud.notify({ type: 'error', message: strings.unavailability_save_error });
        } finally {
            setUnavailSaving(false);
        }
    };

    const resetEmail = async () => {
        const newEmail = (email || '').trim();
        const reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (reg.test(newEmail) == false) {
            await $crud.notify({
                type: 'error',
                message: strings.invalid_email_address
            })
            return;
        }
        try {
            const { data } = await callAPI("/user/resetEmail", {}, 'PUT', { email: newEmail, uiLanguage: contextLanguage, lang: contextLanguage })
            if (!data?.status) {
                await $crud.notify({
                    type: 'error',
                    message: data?.message || strings.invalid_email_address
                })
                return;
            }
            const pendingEmail = data.email || newEmail;
            $user.updateUserData({
                ...(userN || user || {}),
                email: pendingEmail,
                emailVerified: false,
            });
            setIsEditingEmail(false);
            setEmail('');
            setTimeout(() => {
                cardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 200);
            if (!user?.username) {
                // User has no username → they get logged out and redirected,
                // so an inline note wouldn't be seen. Keep the modal here.
                await $crud.confirm({
                    title: "",
                    textContent: data.message,
                    options: {
                        ok: strings.ok,
                        cancel: ""
                    },
                })
                $user.logout();
                history.push('/')
                return;
            }
            setEmailSentNote(data.message);
        } catch (err) {
            await $crud.notify({
                type: 'error',
                message: err?.response?.data?.message || strings.invalid_email_address
            })
        }
    }
    // Asks first (mobile: "Ausloggen / Zum Abmelden bestätigen"), then the shared cleanup.
    const logout = () => confirmAndLogout({ strings, isGerm, dispatch, history });

    const resetPassword = async () => {
        const { password, confirmPassword } = passwordParam
        if (!password) {
            await $crud.notify({
                type: 'error',
                message: strings.please_enter_password
            })
            return false;
        }
        if (password !== confirmPassword) {
            await $crud.notify({
                type: 'error',
                message: strings.pp_not_match
            })
        } else {
            const passwordRegex = /(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+|}{:"?><,./;'\[\]\\\-]).{12,}/;
            if (!passwordParam.password || !passwordRegex.test(passwordParam.password)) {
                await $crud.notify({
                    type: 'error',
                    message: strings.pass_error
                })
            }
            else {
                if (user.username) {
                    // Username accounts confirm with their PIN first.
                    setDialog(null)
                    setPasswordParam({ password: '', confirmPassword: '' })
                    history.push({ pathname: '/security-pin-main', state: { isResetPassword: true, password: password, confirmPassword: confirmPassword } })
                }
                else {
                    const { data } = await callAPI("/user/resetPassword", {}, 'post', passwordParam)
                    if (!data.status) {
                        $crud.notify({
                            type: 'error',
                            message: data.message
                        })
                    } else {
                        setDialog(null)
                        setPasswordParam({ password: '', confirmPassword: '' })
                        try {
                            await $crud.confirm({
                                title: "",
                                textContent: strings.password_change_email_sent,
                                options: {
                                    ok: strings.ok,
                                    cancel: ""
                                },
                            })
                        } catch (_) { /* closed: sign out all the same */ }
                        $user.logout();
                        history.push('/')
                    }
                }
            }
        }
    }

    const resetUserName = async () => {
        if (!username) {
            await $crud.notify({
                type: 'error',
                message: strings.please_enter_username
            })
            return false;
        }
        else if (username == user.username) {
            await $crud.notify({
                type: 'error',
                message: strings.username_same_as_before
            })
            return false;
        }
        else {
            setDialog(null)
            history.push({ pathname: '/security-pin-main', state: { isResetUsername: true, username: username } })
        }
    }

    const handlePinChange = (otp) => {
        setInvalidMsg('');
        setIsInvalid(false);
        setOtp(otp);
    };

    const handlePinChangeC = (otp) => {
        setInvalidMsg('');
        setIsInvalid(false);
        setCOtp(otp);
    };

    const handlePinReset = async () => {
        try {
            setPinLoading(true);
            const data = await $crud.post("/auth/verifyPin", { username: user.username, userPin: otp, language: isGerm ? "de" : "en" });
            if (data.status) {
                setPinLoading(false);
                const datax = await $crud.post("/auth/resetPin", { userPin: cotp });
                if (datax.status) {
                    $crud.notify({
                        type: datax.status ? "success" : "error",
                        message: datax.message,
                    });
                    setOtp('');
                    setCOtp('');
                    setDialog(null);
                } else {
                    setInvalidMsg(datax.message || (strings.not_valid_pin));
                    setIsInvalid(true);
                }
            } else {
                setPinLoading(false);
                setInvalidMsg(strings.not_valid_pin);
                setIsInvalid(true);
            }
        } catch (err) {
            setPinLoading(false);
            setInvalidMsg(strings.not_valid_pin);
            setIsInvalid(true);
        }
    };

    useEffect(() => {
        _checkAndSet()
    }, [])

    const _checkAndSet = async () => {
        const { data } = await callAPI('/user/profile', {}, 'GET');
        const profile = data?.profile;
        if (profile) {
            $user.updateUserData({ ...userN, ...profile });
            setIsTodoNotifOn(!!profile.todoNotificationEnabled);
            setIsEmailPushOn(profile.emailPushNotificationEnabled !== false);
            const resolvedStartup = resolveStartupScreen(profile.startupScreen);
            setStartupScreen(resolvedStartup);
            persistStartupScreen(resolvedStartup);
            setBriefingHour(normalizeBriefingHour(profile.dailyBriefingHour));
            setBriefingModel(normalizeBriefingModel(profile.briefingModelMode));
            setProjectReportModel(normalizeBriefingModel(profile.projectReportModelMode));
            // Auto translation is always enabled.
            dispatch({ type: SET_AUTO_TRANSLATION, status: true });
            localStorage.setItem('autoTrans', 'true');
            const nameTranslationOn = !!profile.translateRoomAndGroupNames;
            setTranslateNames(nameTranslationOn);
            dispatch({ type: SET_TRANSLATE_ROOM_AND_GROUP_NAMES, status: nameTranslationOn });
            setEmailSummaryPreview(!!profile.emailSummaryPreviewEnabled);
            const userLang = (profile.language || localStorage.getItem('language') || 'en').split('-')[0].toLowerCase();
            const enabledLangs = normalizeAutoTranslationLanguages(profile.autoTranslationLanguages);
            dispatch({ type: SET_AUTO_TRANSLATION_LANGUAGES, languages: enabledLangs });
            setAutoTransLangSelection(resolveAutoTranslationSelection(enabledLangs, userLang));
            try {
                if (enabledLangs == null) {
                    localStorage.removeItem('autoTranslationLanguages');
                } else {
                    localStorage.setItem('autoTranslationLanguages', JSON.stringify(enabledLangs));
                }
            } catch (e) {}
        } else {
            dispatch({ type: SET_AUTO_TRANSLATION, status: true });
            localStorage.setItem('autoTrans', 'true');
            const userLang = (localStorage.getItem('language') || 'en').split('-')[0].toLowerCase();
            setAutoTransLangSelection(resolveAutoTranslationSelection(null, userLang));
        }
    }

    // Get current language from context or localStorage, default to 'en'
    const getInitialLanguage = () => {
        const stored = localStorage.getItem('language');
        if (stored && SUPPORTED_LANGUAGE_CODES.includes(stored)) {
            return stored.toUpperCase();
        }
        return isGerm ? 'DE' : 'EN';
    };
    const [language, setLanguage] = React.useState(getInitialLanguage());

    const fetchEmailAccounts = async ({ silent = false } = {}) => {
        if (!silent) setEmailAccountsLoading(true);
        try {
            const { data } = await callAPI('/email/accounts', {}, 'GET');
            let accounts = [];
            if (data && Array.isArray(data)) {
                accounts = data;
            } else if (data?.accounts && Array.isArray(data.accounts)) {
                accounts = data.accounts;
            }
            setEmailAccounts(accounts);
            // Keep Redux in sync so Latest Messages sees the new account without a hard reload.
            dispatch({ type: SET_EMAIL_ACCOUNTS, payload: accounts });
            syncSignaturesToLocalStorage(accounts);
            // Warm up the projects/rooms and company lists so the
            // AccountProjectModal has data ready instantly after a new account
            // is connected.
            if (!promptBuildings || promptBuildings.length === 0) {
                loadPromptBuildings();
            }
            if (!promptCompanies || promptCompanies.length === 0) {
                loadPromptCompanies();
            }
            return accounts;
        } catch (err) {
            console.error('Failed to fetch email accounts:', err);
            return [];
        } finally {
            if (!silent) setEmailAccountsLoading(false);
        }
    };

    // Sub-pages live in ?section= on /profile-setting, so the browser's back button
    // returns to the list. The pane stays mounted (KeepAlive): the URL is only read
    // while the settings are shown.
    const settingsActive = props.location?.pathname === '/profile-setting';
    const urlSection = settingsActive ? new URLSearchParams(props.location?.search || '').get('section') : null;

    // Microsoft Teams (Kjuup.io): the row shows once the server enables Teams for this user, or while
    // the user still has a Teams account (also after the plan lapsed: the list works without it).
    const [teamsRow, setTeamsRow] = useState(null);
    useEffect(() => {
        if (!settingsActive || section || !showIoSettings) return undefined;
        let alive = true;
        listTeamsAccounts()
            .then((res) => {
                const row = teamsSettingsRowState(res);
                if (alive && row) setTeamsRow(row);
            })
            .catch(() => {});
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingsActive, section, showIoSettings]);
    // No `?.` inside `&&` here: eslint-plugin-react-hooks 4.2 then reads every later hook as conditional.
    const teamsRowVisible = !!(teamsRow && teamsRow.visible);
    const teamsRowHasAccount = !!(teamsRow && teamsRow.hasAccount);
    const showTeamsSettings = showIoSettings && teamsRowVisible;
    // With a Teams account (or a read-only archive) the page opens also when Kjuup.io lapsed; Connect
    // and Sync stay locked on the page itself.
    const teamsRowLocked = ioSettingsLocked && !teamsRowHasAccount;
    useEffect(() => {
        if (!settingsActive) return;
        setSection(SETTINGS_SECTIONS.includes(urlSection) ? urlSection : null);
    }, [settingsActive, urlSection]);

    // Older deep links (E-Mail "Add account", the ToDo calendar hint, the Cockpit's Kanäle) pass
    // location.state.openSection: they open the matching sub-page ("chats" scrolls the list to the
    // Kjuup-Chat switch). From the Cockpit (fromCockpit) the sub-page's back button returns there.
    useEffect(() => {
        if (!settingsActive) return;
        const target = props.location?.state?.openSection;
        const backState = props.location?.state?.fromCockpit ? { fromCockpit: true } : undefined;
        if (target === 'chats') {
            setFocusRow('chats');
            history.replace({ ...history.location, state: null });
            return;
        }
        // The Teams page gates itself (it stays open while a Teams account exists).
        if (target === 'teams') {
            history.replace({ pathname: '/profile-setting', search: '?section=teams', state: backState });
            return;
        }
        if (target !== 'email-accounts' && target !== 'email-forward' && target !== 'calendar-sync') return;
        if (ioSettingsLocked) {
            history.replace({ pathname: "/", search: `?section=kjuup-io&focus=${Date.now()}` });
            return;
        }
        if ((target !== 'calendar-sync' && !showIoSettings) || (target === 'calendar-sync' && !showCalendarSyncSettings)) {
            history.replace({ ...history.location, state: null });
            return;
        }
        history.replace({ pathname: '/profile-setting', search: `?section=${target}`, state: backState });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingsActive, props.location?.state?.openSection, showIoSettings, showCalendarSyncSettings, ioSettingsLocked]);

    // The Teams page: stays while a Teams account or archive exists, else the Kjuup.io offer when the
    // plan lapsed, or back to the list when Kjuup.io integrations are not available. Decided once the
    // page reported its account (teamsRow).
    useEffect(() => {
        if (!settingsActive || section !== 'teams' || subscriptionState.loading || !teamsRow) return;
        if (teamsRow.hasAccount) return;
        if (ioSettingsLocked) {
            history.replace({ pathname: "/", search: `?section=kjuup-io&focus=${Date.now()}` });
        } else if (!showIoSettings) {
            history.replace({ pathname: '/profile-setting' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingsActive, section, teamsRow, ioSettingsLocked, showIoSettings, subscriptionState.loading]);

    // A Kjuup.io sub-page without the plan opens the Kjuup.io offer instead.
    useEffect(() => {
        if (!settingsActive || !section || !IO_SECTIONS.has(section) || subscriptionState.loading) return;
        if (ioSettingsLocked) {
            history.replace({ pathname: "/", search: `?section=kjuup-io&focus=${Date.now()}` });
        } else if (!showIoSettings) {
            history.replace({ pathname: '/profile-setting' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingsActive, section, ioSettingsLocked, showIoSettings, subscriptionState.loading]);

    useEffect(() => {
        if (section === 'email-accounts' && hasActiveKjuupIoPlan) fetchEmailAccounts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [section]);

    // Sub-pages start at the top; the list comes back where it was left.
    useEffect(() => {
        const el = scrollRef.current;
        if (el) el.scrollTop = section ? 0 : (listScrollTopRef.current || 0);
    }, [section]);

    // A list row a deep link points at: scrolled into view and flashed once it is rendered
    // (the Kjuup.io workspace rows wait for the subscription).
    useEffect(() => {
        if (!focusRow || section) return undefined;
        const row = document.getElementById(`ps-row-${focusRow}`);
        if (!row) return undefined;
        row.scrollIntoView({ block: 'center', behavior: 'smooth' });
        const timer = setTimeout(() => setFocusRow(null), 2400);
        return () => clearTimeout(timer);
    }, [focusRow, section, isKjuupIoPackage]);

    // "Sicherheit & Anmeldung in zwei Schritten" shows An / Aus (mobile reads GET /user/2fa
    // on every visit): reloaded whenever the list is shown.
    useEffect(() => {
        if (!settingsActive || section) return;
        let cancelled = false;
        twoFactorRequest('get', '/user/2fa').then((res) => {
            if (!cancelled && res && res.status && res.twoFactor) setTwoFactorOn(!!res.twoFactor.enabled);
        });
        return () => { cancelled = true; };
    }, [settingsActive, section]);

    // Company memberships: the Firma group and the role line of the profile card.
    useEffect(() => {
        if (!settingsActive) return undefined;
        let cancelled = false;
        callAPI('/company/my', {}, 'GET')
            .then((res) => {
                const list = res?.data?.status && Array.isArray(res.data.companies) ? res.data.companies : null;
                if (!cancelled && list) setMyCompanies(list);
            })
            .catch(() => {});
        return () => { cancelled = true; };
    }, [settingsActive]);

    const openSectionView = (key) => {
        if (IO_SECTIONS.has(key) && ioSettingsLocked) {
            openCockpitIoOffer();
            return;
        }
        listScrollTopRef.current = scrollRef.current ? scrollRef.current.scrollTop : 0;
        history.push({ pathname: '/profile-setting', search: `?section=${key}`, state: { fromSettingsList: true } });
    };

    const closeSectionView = () => {
        if (history.location?.state?.fromCockpit) openCockpit(dispatch, history);
        else if (history.location?.state?.fromSettingsList) history.goBack();
        else history.replace({ pathname: '/profile-setting' });
    };

    // Kjuup.io workspace switches (also in the side nav). A ref guard: two clicks in
    // the same frame both see workspaceSaving === false.
    const saveWorkspace = async (patch) => {
        if (workspaceSavingRef.current) return;
        workspaceSavingRef.current = true;
        setWorkspaceSaving(true);
        try {
            await saveWorkspacePreferences(dispatch, userN, { ...patch, kjuupIoSetupDone: true });
        } catch (e) {
            $crud.notify({ type: 'error', message: e?.message || strings.something_went_wrong || 'Something went wrong' });
        } finally {
            workspaceSavingRef.current = false;
            setWorkspaceSaving(false);
        }
    };

    const disconnectEmailAccount = async (accountId) => {
        document.body.setAttribute('data-confirm-color', 'violet');
        try {
            try {
                await $crud.confirm({
                    title: "",
                    textContent: strings.email_disconnect_confirm || 'Are you sure you want to disconnect this email account? All synced emails will be removed.',
                    options: {
                        ok: strings.confirm,
                        cancel: strings.cancel
                    }
                });
            } catch (e) { return; }
            setDisconnectingAccountId(accountId);
            try {
                const result = await callAPI(`/email/accounts/${accountId}`, {}, 'DELETE');
                if (result?.data?.status === false) {
                    // Fire-and-forget the toast: awaiting it blocks until the toast is
                    // dismissed, which would keep the "Konto wird getrennt..." overlay
                    // on the account row long after the disconnect already finished.
                    $crud.notify({ type: 'error', message: result?.data?.message || strings.email_account_disconnect_failed || 'Failed to disconnect account' });
                } else {
                    // Refresh the list FIRST so the account row (and its overlay) is gone
                    // the moment the success toast appears, then show a non-blocking toast.
                    const remaining = await fetchEmailAccounts();
                    dispatch({ type: EMAIL_ACCOUNTS_CHANGED, payload: Date.now() });
                    if (!remaining || remaining.length === 0) {
                        dispatch({ type: RESET_UNSEEN_EMAIL_COUNT });
                    }
                    invalidateBadgeCount();
                    try {
                        const { data } = await getBadgeCount({ force: true });
                        if (data?.status) {
                            dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
                        }
                    } catch (_) { /* badge will refresh on next navigation */ }
                    $crud.notify({ type: 'success', message: strings.email_account_disconnected || 'Email account disconnected' });
                }
            } catch (err) {
                console.error('Failed to disconnect email account:', err);
                $crud.notify({ type: 'error', message: strings.email_account_disconnect_failed || 'Failed to disconnect account' });
            } finally {
                setDisconnectingAccountId(null);
            }
        } finally {
            document.body.removeAttribute('data-confirm-color');
        }
    };

    // After a connect flow finishes, detect the newly-added account (by diffing
    // against the ids that existed before) and ask whether it belongs to one
    // specific project (AccountProjectModal).
    // Load the user's projects/rooms into state so the AccountProjectModal
    // type-ahead has data ready the instant it opens. Prefetched when the email
    // section loads (see fetchEmailAccounts) so suggestions appear immediately
    // rather than after a fresh network round-trip once the modal is shown.
    const loadPromptBuildings = async () => {
        if (promptBuildingsLoading.current) return promptBuildings;
        promptBuildingsLoading.current = true;
        try {
            const res = await callAPI('/email/classification/buildings', {}, 'GET');
            const d = res?.data || res;
            const list = d?.buildings && Array.isArray(d.buildings) ? d.buildings : [];
            const blist = list.map((b) => ({ id: b.id, name: b.name }));
            setPromptBuildings(blist);
            return blist;
        } catch (_) {
            return promptBuildings;
        } finally {
            promptBuildingsLoading.current = false;
        }
    };

    // Load the user's company connections so the "create new room" form can offer
    // a company picker when there is more than one. Prefetched alongside buildings.
    const loadPromptCompanies = async () => {
        if (promptCompaniesLoading.current) return promptCompanies;
        promptCompaniesLoading.current = true;
        try {
            const { data } = await callAPI('/company/my', {}, 'GET');
            const list = data?.status && Array.isArray(data.companies) ? data.companies : [];
            const clist = list.map((c) => ({ id: c.id, name: c.name }));
            setPromptCompanies(clist);
            return clist;
        } catch (_) {
            return promptCompanies;
        } finally {
            promptCompaniesLoading.current = false;
        }
    };

    const promptForNewAccount = async (prevIds) => {
        try {
            const { data } = await callAPI('/email/accounts', {}, 'GET');
            const accounts = Array.isArray(data) ? data : (data?.accounts || []);
            const newAcc = accounts.find((a) => !prevIds.includes(String(a.id || a._id)));
            if (!newAcc) return;
            // Reuse the prefetched lists when available; only fetch if we somehow
            // don't have them yet so the picker never opens against empty data.
            if (!promptBuildings || promptBuildings.length === 0) {
                await loadPromptBuildings();
            }
            if (!promptCompanies || promptCompanies.length === 0) {
                await loadPromptCompanies();
            }
            setAccountProjectPrompt(newAcc);
        } catch (_) { /* ignore */ }
    };

    const confirmAccountProject = async ({ buildingId, buildingName, companyId }) => {
        const acc = accountProjectPrompt;
        if (!acc) return;
        setAccountProjectBusy(true);
        try {
            const body = { action: 'setAccountDefault', accountId: acc.id || acc._id };
            if (buildingId) body.buildingId = buildingId;
            else if (buildingName) {
                body.buildingName = buildingName;
                // Only set when creating a new external room for a specific company.
                if (companyId) body.companyId = companyId;
            }
            const { data } = await callAPI('/email/classification/sender-rules', {}, 'PUT', body);
            if (data?.status) {
                // Fire-and-forget the toast (awaiting it blocks until it is dismissed).
                $crud.notify({ type: 'success', message: strings.email_account_project_linked || 'Account linked to project' });
                setAccountProjectPrompt(null);
                fetchEmailAccounts();
            } else {
                // Keep the modal open on failure so the user can correct/retry
                // without losing the room name and company they just entered.
                $crud.notify({ type: 'error', message: data?.message || strings.something_went_wrong || 'Something went wrong' });
            }
        } catch (e) {
            $crud.notify({ type: 'error', message: strings.something_went_wrong || 'Something went wrong' });
        } finally {
            setAccountProjectBusy(false);
        }
    };

    const connectEmailProvider = async (provider, { promptNew = true } = {}) => {
        setConnectingProvider(provider);
        const prevIds = (emailAccounts || []).map((a) => String(a.id || a._id));
        try {
            const { data } = await callAPI(`/email/accounts/auth-url/${provider}`, {}, 'GET');
            const authUrl = data?.url || data?.authUrl || data;
            if (authUrl && typeof authUrl === 'string') {
                const popup = window.open(authUrl, '_blank', 'width=600,height=700,scrollbars=yes');
                if (popup) {
                    const pollTimer = setInterval(() => {
                        if (popup.closed) {
                            clearInterval(pollTimer);
                            setConnectingProvider(null);
                            fetchEmailAccounts();
                            if (promptNew) promptForNewAccount(prevIds);
                        }
                    }, 500);
                } else {
                    setConnectingProvider(null);
                    await $crud.notify({ type: 'error', message: 'Popup blocked. Please allow popups.' });
                }
            } else {
                setConnectingProvider(null);
                await $crud.notify({ type: 'error', message: 'Failed to get authorization URL.' });
            }
        } catch (err) {
            setConnectingProvider(null);
            console.error('Failed to connect email provider:', err);
        }
    };

    const editEmailAccountSettings = async (account) => {
        if (!account) return;
        const provider = String(account.provider || '').toLowerCase();
        if (provider === 'gmail' || provider === 'outlook') {
            await connectEmailProvider(provider, { promptNew: false });
            return;
        }
        if (provider === 'imap') {
            const nextForm = imapFormFromAccount(account);
            setEditingImapAccount(account);
            setImapForm(nextForm);
            setImapError('');
            setShowImapPassword(false);
            setShowImapManual(!!nextForm.host);
            setShowImapModal(true);
        }
    };

    const closeImapModal = () => {
        if (imapConnecting) return;
        setShowImapModal(false);
        setEditingImapAccount(null);
        setShowImapManual(false);
        setShowImapPassword(false);
        setImapError('');
    };

    const connectImapAccount = async () => {
        const { user, password, host, port, tls, smtpHost, smtpPort, smtpSecure } = imapForm;
        if (!user?.trim() || !password) {
            setImapError(strings.email_imap_required || 'Please enter email and password.');
            return;
        }
        setImapError('');
        setImapConnecting(true);
        const prevIds = (emailAccounts || []).map((a) => String(a.id || a._id));
        try {
            let payload = {
                user: user.trim(),
                password,
            };
            if (host?.trim()) {
                payload.host = host.trim();
                payload.port = parseInt(port, 10) || 993;
                payload.tls = tls;
            }
            if (smtpHost?.trim()) {
                payload.smtpHost = smtpHost.trim();
                payload.smtpPort = parseInt(smtpPort, 10) || 587;
                payload.smtpSecure = smtpSecure;
            }
            payload = applyImapHostHint(payload);
            if (editingImapAccount) {
                payload.accountId = editingImapAccount.id || editingImapAccount._id;
            }
            const { data } = await callAPI('/email/accounts/connect/imap', {}, 'POST', payload);
            if (data?.status === false) {
                setImapConnecting(false);
                setImapError(data?.message || strings.email_imap_failed || 'IMAP connection failed.');
            } else {
                // Close the connecting overlay/modal immediately once the account
                // is connected. Do NOT await the toast here — the notify promise
                // resolves only when the toast is dismissed, which would keep the
                // "Verbinde..." overlay on screen for a few seconds. Any ongoing
                // initial sync is surfaced by the per-account "Syncing account…"
                // note (isInitialSyncing) on the connected account instead.
                const wasEditing = !!editingImapAccount;
                setImapForm({ user: '', password: '', host: '', port: '993', tls: true, smtpHost: '', smtpPort: '587', smtpSecure: false });
                setShowImapManual(false);
                setShowImapModal(false);
                setEditingImapAccount(null);
                setImapConnecting(false);
                setImapError('');
                $crud.notify({
                    type: 'success',
                    message: data?.message || strings.email_account_connected,
                });
                fetchEmailAccounts();
                if (!wasEditing) promptForNewAccount(prevIds);
            }
        } catch (err) {
            console.error('IMAP connect failed:', err);
            setImapConnecting(false);
            setImapError(
                err?.data?.message ||
                err?.response?.data?.message ||
                strings.email_imap_failed ||
                'IMAP connection failed.'
            );
        }
        setImapConnecting(false);
    };

    // Connect buttons (Gmail / Outlook / IMAP). Rendered both above the list of
    // connected accounts and below it, so adding another account stays easy even
    // when several are already connected. Disabled when there is no active plan.
    const renderConnectButtons = () => {
        const locked = !hasActiveKjuupIoPlan;
        return (
        <div className="email-connect-buttons">
            <button
                type="button"
                className="kj-btn kj-btn--outline kj-btn--email kj-btn--sm kj-btn--pill kj-btn--soft-hover"
                onClick={() => connectEmailProvider('gmail')}
                disabled={locked || !!connectingProvider}
            >
                {connectingProvider === 'gmail' ? strings.email_connecting : (strings.email_connect_gmail || 'Gmail verbinden')}
            </button>
            <button
                type="button"
                className="kj-btn kj-btn--outline kj-btn--email kj-btn--sm kj-btn--pill kj-btn--soft-hover"
                onClick={() => connectEmailProvider('outlook')}
                disabled={locked || !!connectingProvider}
            >
                {connectingProvider === 'outlook' ? strings.email_connecting : (strings.email_connect_outlook || 'Outlook verbinden')}
            </button>
            <button
                type="button"
                className="kj-btn kj-btn--outline kj-btn--email kj-btn--sm kj-btn--pill kj-btn--soft-hover"
                onClick={() => {
                    setEditingImapAccount(null);
                    setImapForm({ user: '', password: '', host: '', port: '993', tls: true, smtpHost: '', smtpPort: '587', smtpSecure: false });
                    setShowImapManual(false);
                    setShowImapPassword(false);
                    setImapError('');
                    setShowImapModal(true);
                }}
                disabled={locked || !!connectingProvider || imapConnecting}
            >
                {strings.email_connect_imap || 'IMAP verbinden'}
            </button>
        </div>
        );
    };

    // An account is considered to be performing its initial inbox sync when it
    // hasn't completed a sync yet (no lastSyncAt), is not in an error state,
    // and was created very recently. The "recent" guard prevents the spinner
    // from sticking around forever if the BE silently dropped the sync.
    const isAccountInitialSyncing = (account) => {
        if (!account) return false;
        if (account.lastSyncAt) return false;
        if (isEmailAccountConnectionError(account)) return false;
        const createdAtRaw = account.createdAt;
        if (createdAtRaw) {
            const createdMs = new Date(createdAtRaw).getTime();
            if (!Number.isNaN(createdMs)) {
                const ageMs = Date.now() - createdMs;
                if (ageMs > 30 * 60 * 1000) return false;
            }
        }
        return true;
    };

    const triggerSyncForAccount = async (accountId, months) => {
        const account = emailAccounts.find(a => (a.id || a._id) === accountId);
        const currentSynced = account?.syncedMonths || 1;
        // Re-running 3/6 months is allowed (gap-fill). Only block smaller windows
        // that are already covered (e.g. Sync 3 when 6 is already marked).
        if (months < currentSynced) {
            await $crud.notify({
                type: 'info',
                message: (strings.email_sync_already_done || '{months} months already synced').replace('{months}', currentSynced)
            });
            return;
        }
        setSyncingAccountId(accountId + '-' + months);
        try {
            const { data } = await callAPI(
                `/email/accounts/${accountId}/sync`,
                {},
                'POST',
                { syncMonths: months, fullSync: true, forceBackfill: true }
            );
            if (data?.alreadySynced) {
                await $crud.notify({
                    type: 'info',
                    message: (strings.email_sync_already_done || '{months} months already synced').replace('{months}', months)
                });
            } else if (data?.status === false) {
                await $crud.notify({ type: 'error', message: data?.message || 'Sync failed.' });
            } else {
                await $crud.notify({
                    type: 'success',
                    message: data?.message
                        || (strings.email_sync_backfill_started || `Re-syncing last ${months} months — this can take several minutes…`),
                });
                await fetchEmailAccounts({ silent: true });
                setExpandedSyncAccountId(null);
            }
        } catch (err) {
            console.error('Sync failed:', err);
            await $crud.notify({ type: 'error', message: 'Sync failed.' });
        }
        setSyncingAccountId(null);
    };
    
    const handleChangeLanguage = async (eOrCode) => {
        let lang = typeof eOrCode === 'string' ? eOrCode : eOrCode?.target?.value;
        const langLower = String(lang || '').toLowerCase();
        if (!langLower) return;
        const { data } = await callAPI(`/user/language?lang=${langLower}`, {}, 'PUT');
        if (data?.status) {
            let getProfVal = localStorage.getItem("user");
            let filterVal = JSON.parse(getProfVal);
            filterVal = { ...filterVal, language: langLower };
            localStorage.setItem("user", JSON.stringify(filterVal));
        }
        // Update localStorage for multi-language support
        localStorage.setItem('language', langLower);
        const germanFamily = langLower === 'de' || langLower === 'gsw' || langLower === 'wae';
        localStorage.setItem('switch', germanFamily ? '2' : '1');
        
        // Flush translation caches so stale translations from the old language
        // don't persist (especially for image captions loaded from cache).
        clearTranslationCache();
        dispatch({ type: CLEAR_CACHED_MESSAGES });

        dispatch({ type: SET_AUTO_TRANSLATION, status: true });
        props.toggleLanguage?.(langLower);

        // Update context
        setIsGerm(germanFamily);
        if (setContextLanguage) {
            setContextLanguage(langLower);
        }
        setLanguage(langLower.toUpperCase());
    }
    const getUserInterfaceLang = () =>
        (localStorage.getItem('language') || contextLanguage || (typeof language === 'string' ? language.toLowerCase() : 'en'))
            .split('-')[0]
            .toLowerCase();

    const persistAutoTranslationLanguages = async (selection, previousSelection) => {
        const userLang = getUserInterfaceLang();
        const payload = selectionToApiPayload(selection, userLang);
        const seq = ++autoTransSaveSeqRef.current;
        setTransLangSaving(true);
        try {
            const { data } = await callAPI(
                `/user/autoTranslationLanguages`,
                {},
                'PUT',
                { languages: payload }
            );
            if (seq !== autoTransSaveSeqRef.current) return;
            if (data?.status) {
                const enabledLangs = normalizeAutoTranslationLanguages(
                    data.autoTranslationLanguages !== undefined ? data.autoTranslationLanguages : payload
                );
                dispatch({ type: SET_AUTO_TRANSLATION, status: true });
                dispatch({ type: SET_AUTO_TRANSLATION_LANGUAGES, languages: enabledLangs });
                setAutoTransLangSelection(resolveAutoTranslationSelection(enabledLangs, userLang));
                localStorage.setItem('autoTrans', 'true');
                try {
                    if (enabledLangs == null) {
                        localStorage.removeItem('autoTranslationLanguages');
                    } else {
                        localStorage.setItem('autoTranslationLanguages', JSON.stringify(enabledLangs));
                    }
                } catch (e) {}
                clearTranslationCache();
                dispatch({ type: CLEAR_CACHED_MESSAGES });
            } else {
                setAutoTransLangSelection(previousSelection);
                await $crud.notify({
                    type: 'error',
                    message: data?.message || strings.something_went_wrong || 'Something went wrong',
                });
            }
        } catch (e) {
            if (seq !== autoTransSaveSeqRef.current) return;
            setAutoTransLangSelection(previousSelection);
            $crud.notify({
                type: 'error',
                message: strings.something_went_wrong || 'Something went wrong',
            });
        } finally {
            if (seq === autoTransSaveSeqRef.current) setTransLangSaving(false);
        }
    };

    const toggleAutoTransLang = (code) => {
        const previous = autoTransLangSelection;
        const next = previous.includes(code)
            ? previous.filter((c) => c !== code)
            : [...previous, code];
        setAutoTransLangSelection(next);
        persistAutoTranslationLanguages(next, previous);
    };

    // E-mail group of the notifications page (mobile EmailNotificationPro): the chat and
    // article switches once a real address is verified, then the stored address with its
    // state and "Bearbeiten", or the form to add / change it.
    const notificationEmailVerified = !!(userN?.emailVerified || user?.emailVerified);
    const renderEmailNotifications = () => {
        const showForm = !hasRealNotificationEmail || isEditingEmail;
        const showToggles = hasRealNotificationEmail && notificationEmailVerified;
        return (
            <section className="kj-settings-section ps-email-section" ref={cardRef}>
                <h3 className="kj-settings-caption">{strings.pro_settings_email || (isGerm ? "E-Mail" : "E-mail")}</h3>
                {showToggles || !showForm ? (
                    <div className="kj-settings-card">
                        {showToggles ? (
                            <>
                                <SettingsRow
                                    icon="business_messages"
                                    label={strings.email_on}
                                    sub={strings.info_val}
                                    toggle={{ checked: isEmailOn, onChange: () => _onPreEmailNotification() }}
                                />
                                <SettingsRow
                                    icon="brand_awareness"
                                    label={strings.article_email_on}
                                    sub={strings.article_email_info}
                                    toggle={{ checked: isArticleEmailOn, onChange: () => _onToggleArticleEmailNotification() }}
                                />
                            </>
                        ) : null}
                        {!showForm ? (
                            <SettingsRow
                                icon="mail"
                                className="ps-email-address"
                                label={storedNotificationEmail}
                                sub={(
                                    <SettingsTag tone={notificationEmailVerified ? "ok" : "warn"}>
                                        {notificationEmailVerified ? (strings.verified || (isGerm ? "Verifiziert" : "Verified")) : strings.verify_email}
                                    </SettingsTag>
                                )}
                                trailing={(
                                    <button
                                        type="button"
                                        className="kj-btn kj-btn--ghost kj-btn--sm ps-email-edit"
                                        onClick={() => { setEmail(storedNotificationEmail || ''); setEmailSentNote(''); setIsEditingEmail(true); }}
                                    >
                                        {strings.edit}
                                    </button>
                                )}
                            />
                        ) : null}
                    </div>
                ) : null}
                {showForm ? (
                    <Form className="kj-settings-card ps-form-card" onSubmit={(e) => { e.preventDefault(); if (email.trim()) resetEmail(); }}>
                        <label className="ps-field__label" htmlFor="ps-notification-email">{strings.enter_your_email_add}</label>
                        <div className="ps-input">
                            <span className="material-symbols-outlined" aria-hidden="true">mail</span>
                            <input
                                id="ps-notification-email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={strings.enter_your_email_add}
                                autoFocus={isEditingEmail}
                                autoComplete="email"
                            />
                        </div>
                        <div className="ps-form-actions">
                            {hasRealNotificationEmail ? (
                                <button type="button" className="kj-btn kj-btn--secondary" onClick={() => { setEmail(''); setIsEditingEmail(false); }}>
                                    {strings.cancel}
                                </button>
                            ) : null}
                            <button type="submit" className="kj-btn kj-btn--primary" disabled={!email.trim()}>
                                {strings.update}
                            </button>
                        </div>
                    </Form>
                ) : null}
                {emailSentNote ? <SettingsBanner tone="info" icon="mark_email_read" title={emailSentNote} /> : null}
            </section>
        );
    };

    const setPasswordParams = async (key, value) => {
        setPasswordParam(prev => {
            return {
                ...prev,
                [key]: value
            }
        })
    }


    const deleteProfile = async () => {
        try {
            await $crud.confirm({
                title: strings.v2_settings_delete_title || strings.delete_profile,
                textContent: user?.username ? strings.DeleteKjuupPlusText : strings.delete_profile_text,
                options: {
                    ok: strings.confirm,
                    cancel: strings.cancel
                }
            });
        } catch (_) {
            return; // cancelled
        }
        setViewLoader(true)
        const data = await callAPI(`/user/deactivate`, {}, "GET");
        if (data) {
            $crud.notify({
                type: 'success',
                message: strings.profile_deleted_successfully
            })
        }

        await $user.logout();
        localStorage.removeItem("autoTrans")
        dispatch({ type: SET_AUTO_TRANSLATION, status: false })
        setViewLoader(false)
        history.push("/");
    }

    // Switches change at once and roll back when the server says no (mobile owners).
    const _onPreEmailNotification = async () => {
        const emailNotification = !isEmailOn;
        const rollback = () => {
            setIsEmailOn(!emailNotification);
            dispatch({ type: SET_USER, user: { ...userN, emailNotification: !emailNotification } });
        };
        dispatch({ type: SET_USER, user: { ...userN, emailNotification } });
        setIsEmailOn(emailNotification);
        try {
            const { data } = await callAPI(`/user/emailNotification`, {}, "PUT", { emailNotification });
            if (data && data.status === false) rollback();
        } catch (e) {
            rollback();
        }
    }

    const _onToggleArticleEmailNotification = async () => {
        const articleEmailNotification = !isArticleEmailOn;
        const rollback = () => {
            setIsArticleEmailOn(!articleEmailNotification);
            dispatch({ type: SET_USER, user: { ...userN, articleEmailNotification: !articleEmailNotification } });
        };
        dispatch({ type: SET_USER, user: { ...userN, articleEmailNotification } });
        setIsArticleEmailOn(articleEmailNotification);
        try {
            const { data } = await callAPI(`/user/articleEmailNotification`, {}, "PUT", {
                articleEmailNotification
            });
            if (data && data.status === false) rollback();
        } catch (e) {
            rollback();
        }
    }

    const _onToggleTodoNotification = async () => {
        const todoNotificationEnabled = !isTodoNotifOn;
        setIsTodoNotifOn(todoNotificationEnabled);
        $user.updateUserData({ ...userN, todoNotificationEnabled });
        try {
            const { data } = await callAPI(`/user/todoNotification`, {}, "PUT", { todoNotificationEnabled });
            if (data && data.status === false) throw new Error(data.message || 'todoNotification failed');
            invalidateBadgeCount();
            try {
                const { data } = await getBadgeCount({ force: true });
                if (data?.status) {
                    dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
                }
            } catch (_) { /* badge will refresh on next navigation / socket */ }
        } catch (e) {
            setIsTodoNotifOn(!todoNotificationEnabled);
            $user.updateUserData({ ...userN, todoNotificationEnabled: !todoNotificationEnabled });
        }
    }

    const _onToggleEmailPushNotification = async () => {
        const emailPushNotificationEnabled = !isEmailPushOn;
        setIsEmailPushOn(emailPushNotificationEnabled);
        $user.updateUserData({ ...userN, emailPushNotificationEnabled });
        try {
            const { data } = await callAPI(`/user/emailPushNotification`, {}, "PUT", { emailPushNotificationEnabled });
            if (data && data.status === false) throw new Error(data.message || 'emailPushNotification failed');
        } catch (e) {
            setIsEmailPushOn(!emailPushNotificationEnabled);
            $user.updateUserData({ ...userN, emailPushNotificationEnabled: !emailPushNotificationEnabled });
        }
    }

    const _onChangeStartupScreen = async (value) => {
        const next = resolveStartupScreen(value);
        if (next === startupScreen || startupScreenSaving) return;
        const previous = startupScreen;
        setStartupScreen(next);
        setStartupScreenSaving(true);
        dispatch({ type: SET_USER, user: { ...userN, startupScreen: next } });
        $user.updateUserData({ ...userN, startupScreen: next });
        persistStartupScreen(next);
        try {
            const { data } = await callAPI(`/user/startupScreen`, {}, "PUT", { startupScreen: next });
            if (data && data.status === false) {
                throw new Error(data.message || "Failed to update startup screen");
            }
            $crud.notify({ type: 'success', message: strings.startup_screen_saved || (isGerm ? 'Startbildschirm aktualisiert' : 'Startup screen updated') });
        } catch (e) {
            setStartupScreen(previous);
            dispatch({ type: SET_USER, user: { ...userN, startupScreen: previous } });
            $user.updateUserData({ ...userN, startupScreen: previous });
            persistStartupScreen(previous);
            $crud.notify({ type: 'error', message: strings.something_went_wrong || 'Something went wrong' });
        } finally {
            setStartupScreenSaving(false);
        }
    };

    const _onToggleTranslateNames = async () => {
        if (translateNamesSaving) return;
        const next = !translateNames;
        const previous = translateNames;
        setTranslateNames(next);
        setTranslateNamesSaving(true);
        dispatch({ type: SET_TRANSLATE_ROOM_AND_GROUP_NAMES, status: next });
        dispatch({ type: SET_USER, user: { ...userN, translateRoomAndGroupNames: next } });
        $user.updateUserData({ ...userN, translateRoomAndGroupNames: next });
        try {
            const { data } = await callAPI(`/user/translateRoomAndGroupNames`, {}, "PUT", { enabled: next });
            if (data && data.status === false) {
                throw new Error(data.message || "Failed to update name translation");
            }
        } catch (e) {
            setTranslateNames(previous);
            dispatch({ type: SET_TRANSLATE_ROOM_AND_GROUP_NAMES, status: previous });
            dispatch({ type: SET_USER, user: { ...userN, translateRoomAndGroupNames: previous } });
            $user.updateUserData({ ...userN, translateRoomAndGroupNames: previous });
            await $crud.notify({
                type: 'error',
                message: e?.message || strings.something_went_wrong || 'Something went wrong',
            });
        } finally {
            setTranslateNamesSaving(false);
        }
    };

    const _onToggleEmailSummaryPreview = async () => {
        if (emailSummaryPreviewSaving) return;
        const next = !emailSummaryPreview;
        const previous = emailSummaryPreview;
        setEmailSummaryPreview(next);
        setEmailSummaryPreviewSaving(true);
        dispatch({ type: SET_USER, user: { ...userN, emailSummaryPreviewEnabled: next } });
        $user.updateUserData({ ...userN, emailSummaryPreviewEnabled: next });
        try {
            const { data } = await callAPI(`/user/emailSummaryPreview`, {}, "PUT", { enabled: next });
            if (data && data.status === false) {
                throw new Error(data.message || "Failed to update email summary preview");
            }
        } catch (e) {
            setEmailSummaryPreview(previous);
            dispatch({ type: SET_USER, user: { ...userN, emailSummaryPreviewEnabled: previous } });
            $user.updateUserData({ ...userN, emailSummaryPreviewEnabled: previous });
            await $crud.notify({
                type: 'error',
                message: e?.message || strings.something_went_wrong || 'Something went wrong',
            });
        } finally {
            setEmailSummaryPreviewSaving(false);
        }
    };

    const _onChangeBriefingHour = async (value) => {
        const next = normalizeBriefingHour(value);
        if (next === briefingHour || briefingHourSaving) return;
        const previous = briefingHour;
        setBriefingHour(next);
        setBriefingHourSaving(true);
        dispatch({ type: SET_USER, user: { ...userN, dailyBriefingHour: next } });
        $user.updateUserData({ ...userN, dailyBriefingHour: next });
        try {
            const { data } = await callAPI(`/user/dailyBriefingHour`, {}, "PUT", { dailyBriefingHour: next });
            if (data && data.status === false) {
                throw new Error(data.message || "Failed to update daily briefing hour");
            }
            $crud.notify({ type: 'success', message: strings.daily_briefing_hour_saved || (isGerm ? 'Uhrzeit für den Tagesbericht aktualisiert' : 'Daily report time updated') });
        } catch (e) {
            setBriefingHour(previous);
            dispatch({ type: SET_USER, user: { ...userN, dailyBriefingHour: previous } });
            $user.updateUserData({ ...userN, dailyBriefingHour: previous });
            $crud.notify({ type: 'error', message: strings.something_went_wrong || 'Something went wrong' });
        } finally {
            setBriefingHourSaving(false);
        }
    }

    const _onChangeBriefingModel = async (value) => {
        const next = normalizeBriefingModel(value);
        if (next === briefingModel || briefingModelSaving) return;
        const previous = briefingModel;
        setBriefingModel(next);
        setBriefingModelSaving(true);
        dispatch({ type: SET_USER, user: { ...userN, briefingModelMode: next } });
        $user.updateUserData({ ...userN, briefingModelMode: next });
        try {
            const { data } = await callAPI(`/user/briefingModel`, {}, "PUT", { mode: next });
            if (data && data.status === false) {
                throw new Error(data.message || "Failed to update the daily report model");
            }
            $crud.notify({ type: 'success', message: strings.daily_briefing_model_saved || (isGerm ? 'KI-Modell für den Tagesbericht aktualisiert' : 'Daily report model updated') });
        } catch (e) {
            setBriefingModel(previous);
            dispatch({ type: SET_USER, user: { ...userN, briefingModelMode: previous } });
            $user.updateUserData({ ...userN, briefingModelMode: previous });
            $crud.notify({ type: 'error', message: strings.something_went_wrong || 'Something went wrong' });
        } finally {
            setBriefingModelSaving(false);
        }
    }

    const _onChangeProjectReportModel = async (next) => {
        if (next === projectReportModel || projectReportSaving) return;
        const previous = projectReportModel;
        setProjectReportModel(next);
        setProjectReportSaving(true);
        dispatch({ type: SET_USER, user: { ...userN, projectReportModelMode: next } });
        $user.updateUserData({ ...userN, projectReportModelMode: next });
        try {
            const { data } = await callAPI(`/user/projectReportModel`, {}, "PUT", { mode: next });
            if (data && data.status === false) {
                throw new Error(data.message || "Failed to update the project report model");
            }
        } catch (e) {
            setProjectReportModel(previous);
            dispatch({ type: SET_USER, user: { ...userN, projectReportModelMode: previous } });
            $user.updateUserData({ ...userN, projectReportModelMode: previous });
            $crud.notify({ type: 'error', message: strings.something_went_wrong || 'Something went wrong' });
        } finally {
            setProjectReportSaving(false);
        }
    }

    // The Kjuup forwarding address (provider 'forward') has its own page.
    const mailboxAccounts = emailAccounts.filter((a) => String(a.provider || '').toLowerCase() !== 'forward');

    // ---- E-mail accounts (Kjuup.io): the account list and its modals, as before ----
    const renderEmailAccounts = () => (
        <>
            {!hasActiveKjuupIoPlan ? (
                <>
                    {showCompanyTrialEndedNote ? (
                        <div className="profile-setting__trial-ended">
                            <div className="profile-setting__trial-ended-title">
                                {strings.kjuup_io_company_trial_ended_title ||
                                    strings.kjuup_io_trial_ended_title ||
                                    'Free trial ended!'}
                            </div>
                            <div className="profile-setting__trial-ended-body">
                                {companyTrialEndedAskBody(strings, subscriptionState)}
                            </div>
                        </div>
                    ) : hasUsedTrial && !isKjuupPlusMember ? (
                        <div className="profile-setting__trial-ended">
                            <div className="profile-setting__trial-ended-title">
                                {strings.kjuup_io_trial_ended_title || 'Your free trial has ended'}
                            </div>
                            <div className="profile-setting__trial-ended-body">
                                {strings.kjuup_io_trial_ended_body ||
                                    'Subscribe to Kjuup.io to keep using email and other premium features.'}
                            </div>
                        </div>
                    ) : null}
                    {renderConnectButtons()}
                    {showKjuupIoUpsellUi && !isKjuupPlusMember ? (
                    <button
                        type="button"
                        onClick={() =>
                            navigateToKjuupIoBilling(history, subscriptionState)
                        }
                        className="profile-setting__io-cta"
                    >
                        {hasUsedTrial
                            ? (strings.kjuup_io_subscribe_to_continue ||
                                strings.kjuup_io_subscribe_now ||
                                'Subscribe now')
                            : (strings.kjuup_io_activate_to_connect_email ||
                                'Activate Kjuup.io to connect email accounts')}
                    </button>
                    ) : null}
                </>
            ) : emailAccountsLoading ? (
                <div className="email-accounts-skeleton">
                    <div className="email-skeleton-line email-skeleton-line--short" />
                    <div className="email-skeleton-line email-skeleton-line--long" />
                    <div className="email-skeleton-line email-skeleton-line--long" />
                    <div className="profile-setting__skeleton-pills">
                        <div className="email-skeleton-pill" />
                        <div className="email-skeleton-pill" />
                    </div>
                    <div className="email-skeleton-divider" />
                    <div className="email-skeleton-line email-skeleton-line--short" />
                    <div className="profile-setting__skeleton-pills profile-setting__skeleton-pills--tight">
                        <div className="email-skeleton-pill" />
                        <div className="email-skeleton-pill" />
                        <div className="email-skeleton-pill" />
                    </div>
                </div>
            ) : (
                <>
                    {mailboxAccounts.length > 0 && (
                        <div className="profile-setting__accounts">
                            <div className="profile-setting__accounts-title">
                                {strings.email_connected_accounts || 'Connected Accounts'}
                            </div>
                            <p className="email-sync-info-text">
                                {strings.email_sync_info || 'When connecting an email account, emails from the last month are synchronised by default. You can extend the sync period below.'}
                            </p>
                            <div className="profile-setting__accounts-connect">
                                {renderConnectButtons()}
                            </div>
                            {mailboxAccounts.map((account) => {
                                const accId = account.id || account._id;
                                const isDisconnecting = disconnectingAccountId === accId;
                                const isInitialSyncing = isAccountInitialSyncing(account);
                                const hasConnectionError = isEmailAccountConnectionError(account);
                                const providerKey = String(account.provider || '').toLowerCase();
                                const isEditingThis =
                                    connectingProvider === providerKey ||
                                    (providerKey === 'imap' &&
                                        ((editingImapAccount && (editingImapAccount.id || editingImapAccount._id) === accId) ||
                                            (imapConnecting && imapForm.user === account.email)));
                                return (
                                <div
                                    key={accId}
                                    className={`email-settings-account profile-setting__account${hasConnectionError ? ' email-settings-account--error' : ''}`}
                                >
                                    {isDisconnecting && (
                                        <div className="email-transition-overlay">
                                            <span className="material-symbols-outlined email-transition-icon">link_off</span>
                                            <div className="email-transition-text">{strings.email_disconnecting || 'Konto wird getrennt...'}</div>
                                            <div className="email-transition-shimmer" />
                                        </div>
                                    )}
                                    {(() => {
                                        const currentSynced = account.syncedMonths || 1;
                                        const isExpanded = expandedSyncAccountId === accId;
                                        return (
                                            <>
                                                <div className="email-settings-account-row">
                                                    <div className="email-settings-account-info">
                                                        <span className="material-symbols-outlined email-settings-account-mail-icon" aria-hidden>
                                                            {hasConnectionError ? 'error' : 'mail'}
                                                        </span>
                                                        <div className="email-settings-account-text">
                                                            <div className="email-settings-account-email">
                                                                {account.email || account.name}
                                                            </div>
                                                            <div className={`email-settings-account-provider${hasConnectionError ? ' email-settings-account-status-error' : ''}`}>
                                                                {account.provider}
                                                                {hasConnectionError ? (
                                                                    <span className="profile-setting__account-error">
                                                                        · {strings.email_connection_error || 'Connection issue'}
                                                                    </span>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="email-settings-account-actions">
                                                        {!hasConnectionError && !isExpanded ? (
                                                            <button
                                                                type="button"
                                                                className="kj-btn kj-btn--outline kj-btn--email kj-btn--sm kj-btn--pill kj-btn--soft-hover email-sync-period-btn"
                                                                disabled={!!syncingAccountId || !!disconnectingAccountId || isInitialSyncing}
                                                                onClick={() => setExpandedSyncAccountId(accId)}
                                                            >
                                                                {currentSynced >= 6
                                                                    ? (strings.email_sync_retry || strings.email_sync_more || 'Sync more months')
                                                                    : (strings.email_sync_more || 'Sync more months')}
                                                            </button>
                                                        ) : null}
                                                        <button
                                                            type="button"
                                                            className={hasConnectionError
                                                                ? 'kj-btn kj-btn--primary kj-btn--danger kj-btn--sm kj-btn--pill email-reconnect-btn'
                                                                : 'kj-btn kj-btn--outline kj-btn--email kj-btn--sm kj-btn--pill kj-btn--soft-hover email-disconnect-btn'}
                                                            disabled={!!connectingProvider || imapConnecting || !!disconnectingAccountId || isEditingThis}
                                                            onClick={() => editEmailAccountSettings(account)}
                                                            title={hasConnectionError
                                                                ? (strings.email_reconnect || 'Reconnect')
                                                                : (strings.email_edit_settings || 'Edit settings')}
                                                        >
                                                            {isEditingThis
                                                                ? (strings.email_connecting || 'Connecting...')
                                                                : hasConnectionError
                                                                    ? (strings.email_reconnect || 'Reconnect')
                                                                    : (strings.email_edit_settings || 'Edit settings')}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="kj-btn kj-btn--outline kj-btn--danger kj-btn--sm kj-btn--pill kj-btn--soft-hover email-disconnect-btn email-disconnect-btn--danger"
                                                            onClick={() => disconnectEmailAccount(accId)}
                                                            title={strings.email_disconnect}
                                                            disabled={!!disconnectingAccountId}
                                                        >
                                                            {strings.email_disconnect}
                                                        </button>
                                                    </div>
                                                </div>
                                                {isExpanded ? (
                                                    <div className="email-sync-period-buttons email-sync-period-buttons--expanded">
                                                        {[3, 6].map((m) => {
                                                            // Smaller windows already covered stay disabled;
                                                            // equal window stays clickable to gap-fill / re-sync.
                                                            const coveredSmaller = m < currentSynced;
                                                            const canRetry = m === currentSynced;
                                                            return (
                                                                <button
                                                                    key={m}
                                                                    type="button"
                                                                    className="kj-btn kj-btn--outline kj-btn--email kj-btn--sm kj-btn--pill kj-btn--soft-hover"
                                                                    disabled={!!syncingAccountId || !!disconnectingAccountId || isInitialSyncing || coveredSmaller}
                                                                    onClick={() => triggerSyncForAccount(accId, m)}
                                                                    title={coveredSmaller
                                                                        ? (strings.email_sync_already_done || '{months} months already synced').replace('{months}', currentSynced)
                                                                        : (canRetry ? (strings.email_sync_backfill_hint || 'Fill missing older emails') : '')}
                                                                >
                                                                    {syncingAccountId === accId + '-' + m
                                                                        ? (strings.email_syncing || 'Syncing...')
                                                                        : coveredSmaller
                                                                            ? (strings.email_sync_already_done || '{months} months already synced').replace('{months}', m)
                                                                            : canRetry
                                                                                ? (strings[`email_sync_retry_${m}_months`] || strings[`email_sync_${m}_months`] || `Sync last ${m} months`)
                                                                                : (strings[`email_sync_${m}_months`] || `Sync last ${m} months`)}
                                                                </button>
                                                            );
                                                        })}
                                                        <button
                                                            type="button"
                                                            className="kj-btn kj-btn--secondary kj-btn--sm kj-btn--pill"
                                                            disabled={!!syncingAccountId || !!disconnectingAccountId}
                                                            onClick={() => setExpandedSyncAccountId(null)}
                                                        >
                                                            {strings.cancel || 'Cancel'}
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </>
                                        );
                                    })()}
                                    {hasConnectionError && !isDisconnecting && (
                                        <div className="email-error-note" role="alert">
                                            <span className="material-symbols-outlined email-error-note-icon" aria-hidden>warning</span>
                                            <span className="email-error-note-text">
                                                {strings.email_connection_error_hint || 'This account could not be synced. Reconnect to restore incoming email.'}
                                            </span>
                                        </div>
                                    )}
                                    {isInitialSyncing && !isDisconnecting && !hasConnectionError && (
                                        <div className="email-syncing-note" role="status" aria-live="polite">
                                            <span className="material-symbols-outlined email-syncing-note-icon" aria-hidden>sync</span>
                                            <span className="email-syncing-note-text">
                                                {strings.email_syncing_account || 'Syncing account, this may take a few minutes…'}
                                            </span>
                                        </div>
                                    )}
                                    <EmailSignatureEditor accountId={accId} initialSignature={account.emailSignature || ''} strings={strings} />
                                </div>
                                );
                            })}
                            <EmailClassificationRules />
                        </div>
                    )}

                    {mailboxAccounts.length === 0 && (
                        <div>
                            <div className="profile-setting__accounts-title">
                                {strings.email_add_account || 'Add Account'}
                            </div>
                            {renderConnectButtons()}
                            <button
                                type="button"
                                className="kj-btn kj-btn--ghost kj-btn--sm profile-setting__forward-hint"
                                onClick={() => openSectionView('email-forward')}
                            >
                                <span className="material-symbols-outlined" aria-hidden="true">forward_to_inbox</span>
                                <span>{tr('email_forward_hint', 'Lieber kein Postfach verbinden? E-Mails an eine Kjuup-Adresse weiterleiten', 'Rather not connect a mailbox? Forward emails to a Kjuup address')}</span>
                            </button>
                        </div>
                    )}
                </>
            )}
        </>
    );

    const renderEmailModals = () => (
        <>
            {showImapModal && createPortal(
                <div className="imap-modal-overlay" onClick={closeImapModal}>
                    <div className="imap-modal" onClick={(e) => e.stopPropagation()}>
                        {imapConnecting ? (
                            <div className="email-transition-screen">
                                <span className="material-symbols-outlined email-transition-icon">mail</span>
                                <div className="email-transition-text">{strings.email_connecting || 'Verbinde mit Mailserver...'}</div>
                                <div className="email-transition-shimmer" />
                            </div>
                        ) : (
                        <>
                        <div className="imap-modal-header">
                            <span className="profile-setting__imap-title">
                                {editingImapAccount
                                    ? (strings.email_imap_edit_title || 'Edit IMAP account')
                                    : (strings.email_imap_title || 'IMAP')}
                            </span>
                            <span
                                className="material-symbols-outlined pointer profile-setting__imap-close"
                                onClick={closeImapModal}
                            >close</span>
                        </div>
                        <p className="profile-setting__imap-hint">
                            {editingImapAccount
                                ? (strings.email_imap_edit_hint || 'Update the email address or password, then save to reconnect this account.')
                                : (strings.email_imap_hint || 'Connect any email account via IMAP.')}
                        </p>
                        {imapError ? (
                            <div className="imap-modal-error" role="alert">{imapError}</div>
                        ) : null}
                        <Form
                            className="add_company_from"
                            onSubmit={(e) => {
                                e.preventDefault();
                                if (!connectingProvider && !imapConnecting) {
                                    connectImapAccount();
                                }
                            }}
                        >
                            <Form.Group controlId="imapEmailModal">
                                <Form.Control
                                    type="text"
                                    value={imapForm.user}
                                    onChange={(e) => setImapForm((f) => ({ ...f, user: e.target.value }))}
                                    placeholder={strings.email_imap_user || 'E-Mail'}
                                    autoComplete="username"
                                />
                            </Form.Group>
                            <Form.Group controlId="imapPasswordModal">
                                <div className="profile-setting__pw-row">
                                    <Form.Control
                                        type={showImapPassword ? "text" : "password"}
                                        value={imapForm.password}
                                        onChange={(e) => setImapForm((f) => ({ ...f, password: e.target.value }))}
                                        placeholder={strings.email_imap_password || 'Passwort'}
                                        autoComplete="new-password"
                                    />
                                    <div className="profile-setting__pw-eye-wrap">
                                        <span
                                            className="material-symbols-outlined pointer profile-setting__pw-eye"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowImapPassword(!showImapPassword);
                                            }}
                                        >
                                            {showImapPassword ? 'visibility' : 'visibility_off'}
                                        </span>
                                    </div>
                                </div>
                            </Form.Group>
                            <div
                                className="profile-setting__imap-manual-toggle"
                                onClick={() => setShowImapManual((v) => !v)}
                            >
                                <span className={`material-symbols-outlined profile-setting__imap-chevron${showImapManual ? " profile-setting__imap-chevron--open" : ""}`}>
                                    chevron_right
                                </span>
                                <span className="profile-setting__imap-manual-label">
                                    {strings.email_imap_manual_toggle || 'Manual server settings'}
                                </span>
                            </div>
                            {showImapManual && (
                                <>
                                    <div className="profile-setting__imap-section">
                                        {strings.email_imap_incoming || 'Incoming Mail (IMAP)'}
                                    </div>
                                    <Form.Group controlId="imapHostModal">
                                        <Form.Control
                                            type="text"
                                            value={imapForm.host}
                                            onChange={(e) => setImapForm((f) => ({ ...f, host: e.target.value }))}
                                            placeholder={strings.email_imap_host || 'IMAP Server (e.g. imap.ionos.de)'}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <div className="profile-setting__imap-port-row">
                                        <Form.Control
                                            type="number"
                                            value={imapForm.port}
                                            onChange={(e) => setImapForm((f) => ({ ...f, port: e.target.value }))}
                                            placeholder={strings.email_imap_port || 'Port'}
                                            autoComplete="off"
                                            className="profile-setting__imap-port"
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            checked={imapForm.tls}
                                            onChange={(e) => setImapForm((f) => ({ ...f, tls: e.target.checked }))}
                                            id="imapTlsCheck"
                                            label="SSL/TLS"
                                            className="profile-setting__imap-tls"
                                        />
                                    </div>
                                    <div className="profile-setting__imap-section profile-setting__imap-section--spaced">
                                        {strings.email_smtp_outgoing || 'Outgoing Mail (SMTP)'}
                                    </div>
                                    <Form.Group controlId="smtpHostModal">
                                        <Form.Control
                                            type="text"
                                            value={imapForm.smtpHost}
                                            onChange={(e) => setImapForm((f) => ({ ...f, smtpHost: e.target.value }))}
                                            placeholder={strings.email_smtp_host || 'SMTP Server (e.g. smtp.ionos.de)'}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <div className="profile-setting__imap-port-row">
                                        <Form.Control
                                            type="number"
                                            value={imapForm.smtpPort}
                                            onChange={(e) => setImapForm((f) => ({ ...f, smtpPort: e.target.value }))}
                                            placeholder={strings.email_smtp_port || 'Port'}
                                            autoComplete="off"
                                            className="profile-setting__imap-port"
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            checked={imapForm.smtpSecure}
                                            onChange={(e) => setImapForm((f) => ({ ...f, smtpSecure: e.target.checked }))}
                                            id="smtpSecureCheck"
                                            label="SSL/TLS"
                                            className="profile-setting__imap-tls"
                                        />
                                    </div>
                                </>
                            )}
                            <button
                                type="submit"
                                className="kj-btn kj-btn--primary kj-btn--email kj-btn--block imap-modal-connect-btn"
                                disabled={!!connectingProvider || imapConnecting}
                            >
                                {editingImapAccount
                                    ? (strings.email_imap_save || 'Save & reconnect')
                                    : (strings.email_imap_connect_btn || 'IMAP-Konto verbinden')}
                            </button>
                        </Form>
                        </>
                        )}
                    </div>
                </div>,
                document.body
            )}

            {accountProjectPrompt && createPortal(
                <AccountProjectModal
                    account={accountProjectPrompt}
                    buildings={promptBuildings}
                    companies={promptCompanies}
                    busy={accountProjectBusy}
                    onConfirm={confirmAccountProject}
                    onSkip={() => { if (!accountProjectBusy) setAccountProjectPrompt(null); }}
                    strings={strings}
                />,
                document.body
            )}
        </>
    );

    // ---- Personal settings list (mobile Pro settings) ----
    const tr = (key, de, en) => strings[key] || (isGerm ? de : en);
    const onLabel = tr('pro_settings_on', 'An', 'On');
    const offLabel = tr('pro_settings_off', 'Aus', 'Off');
    const closeDialog = () => setDialog(null);

    // Profile card: name, then "Position · Firma" (else the e-mail / @username).
    const me = { ...(user || {}), ...(userN || {}) };
    const rawEmail = typeof me.email === 'string' ? me.email.trim() : '';
    const displayName = String(me.fullName || [me.firstName, me.lastName].filter(Boolean).join(' ') || '').trim()
        || (me.username ? `@${me.username}` : '');
    const profileCompanies = Array.isArray(me.companies) ? me.companies.filter((c) => c && (c.name || c.companyName)) : [];
    const memberCompanies = (myCompanies || []).filter((c) => c && c.id != null);
    const firstCompany = profileCompanies[0] || memberCompanies[0] || null;
    const firstMembership = firstCompany ? memberCompanies.find((c) => String(c.id) === String(firstCompany.id)) : null;
    const positionRaw = (firstMembership && firstMembership.position) || (firstCompany && firstCompany.position) || '';
    const positionLabel = positionRaw ? (convertPosition(strings, positionRaw) || positionRaw) : '';
    const firstRole = String(me.buildingIndustryRole || '').split(',').map((r) => r.trim()).filter(Boolean)[0] || '';
    const roleLabel = firstRole ? (convertBranchRole(firstRole, contextLanguage || isGerm) || firstRole) : '';
    const roleLine = [positionLabel || roleLabel, firstCompany ? (firstCompany.name || firstCompany.companyName) : '']
        .filter(Boolean)
        .join(' · ');
    const profileSub = roleLine || (isGeneratedNotificationEmail(rawEmail) ? (me.username ? `@${me.username}` : '') : rawEmail);
    const avatarSrc = me.avatar ? `${BASE_URL}${me.avatar}` : '';

    // Plan card: "Paket Kjuup+". Kjuup.io users open the plans page (seats, billing, cancel);
    // everyone else gets "Upgrade", which opens the package offers on the cockpit.
    const packageLabel = resolvePackageLabel(profile, subscriptionState);
    const planClickable = !!stripeUiEnabled && isKjuupIoPackage;

    // Firma group.
    const companyCount = Math.max(memberCompanies.length, Number(me.companiesCount) || 0, profileCompanies.length);
    const docsCompany = memberCompanies.find((c) => c.isKjuup);
    const adminCompany = memberCompanies.find((c) => viewerAssignsCompanySeats(c));

    // Values on the rows.
    const currentLangCode = String(language || '').toLowerCase();
    const currentLang = SUPPORTED_LANGUAGES.find((lang) => lang.code === currentLangCode);
    const allTranslation = autoTransLangSelection.length >= TRANSLATION_LANGUAGES.length;
    const translationCodes = autoTransLangSelection.map((code) => String(code).toUpperCase());
    const translationValue = allTranslation
        ? tr('pro_settings_all', 'Alle', 'All')
        : translationCodes.length > 3
            ? `${translationCodes.slice(0, 3).join(', ')} +${translationCodes.length - 3}`
            : translationCodes.join(', ');
    const reportTimeLabel = strings.daily_briefing_hour_label || strings.daily_briefing_label || tr('daily_briefing_hour_label', 'Uhrzeit für den Tagesbericht', 'Daily report time');
    const briefingModelLabel = tr('daily_briefing_model_label', 'KI-Modell für den Tagesbericht', 'AI model for the daily report');
    const briefingModelName = (mode) => (mode === 'external'
        ? tr('daily_briefing_model_external', 'Extern (Mistral)', 'External (Mistral)')
        : tr('daily_briefing_model_internal', 'Intern (Kjuup-KI)', 'Internal (Kjuup AI)'));
    const briefingModelHint = (mode) => (mode === 'external'
        ? tr('daily_briefing_model_external_info',
            'Neuestes passendes Modell von Mistral AI (Frankreich). Inhalte aus Ihren Projekten werden zur Erstellung an Mistral übermittelt.',
            'Latest suitable model from Mistral AI (France). Content from your projects is sent to Mistral to write the report.')
        : tr('daily_briefing_model_internal_info',
            'Läuft auf Kjuup-eigenen Servern. Inhalte verlassen Kjuup nicht.',
            'Runs on Kjuup\'s own servers. Content never leaves Kjuup.'));
    const briefingInfoTitle = tr('daily_briefing_model_notice_title', 'Hinweis zur Datenverarbeitung', 'Data processing notice');
    const briefingInfoParagraphs = [
        tr('daily_briefing_model_notice_1',
            'Mit dieser Einstellung erstellt nicht mehr die Kjuup-KI auf unseren eigenen Servern Ihren Tagesbericht, sondern ein Sprachmodell des externen KI-Anbieters Mistral AI SAS (Paris, Frankreich).',
            'With this setting, your daily report is no longer written by the Kjuup AI on our own servers, but by a language model of the external AI provider Mistral AI SAS (Paris, France).'),
        tr('daily_briefing_model_notice_2',
            'Für die Erstellung übermittelt Kjuup die Inhalte, die in den Bericht einfließen, an Mistral: E-Mails, Nachrichten und Aufgaben aus Ihren Projekten sowie Texte aus deren Anhängen. Diese Inhalte können personenbezogene Daten Dritter enthalten, etwa Namen und Kontaktdaten von Absendern.',
            'To write the report, Kjuup sends the content it is based on to Mistral: emails, messages and tasks from your projects, and text from their attachments. This content may include personal data of third parties, such as names and contact details of senders.'),
        tr('daily_briefing_model_notice_3',
            'Mistral verarbeitet diese Daten als Auftragsverarbeiter von Kjuup ausschließlich zur Erstellung Ihres Berichts und verwendet sie nicht zum Training von KI-Modellen. Die Verarbeitung erfolgt innerhalb der Europäischen Union.',
            'Mistral processes this data as Kjuup\'s data processor solely to write your report and does not use it to train AI models. Processing takes place within the European Union.'),
        tr('daily_briefing_model_notice_4',
            'Bitte aktivieren Sie diese Option nur, wenn Sie berechtigt sind, diese Inhalte an einen externen Dienstleister weiterzugeben – bei Firmenkonten in Abstimmung mit Ihrem Unternehmen. Sie können jederzeit zur internen Kjuup-KI zurückwechseln; ab dem nächsten Bericht werden dann keine Inhalte mehr an Mistral übermittelt.',
            'Please enable this option only if you are entitled to share this content with an external service provider – for company accounts, in agreement with your company. You can switch back to the internal Kjuup AI at any time; from the next report on, no content is sent to Mistral.'),
    ];

    const projectReportLabel = tr('project_report_label', 'Projektberichte mit Mistral erstellen', 'Write project reports with Mistral');
    const projectReportInfoParagraphs = [
        tr('project_report_notice_1',
            'Projektberichte zeigen in der Übersicht eines Projekts den aktuellen Stand und die wichtigsten Prioritäten. Sie werden jede Nacht für Projekte mit neuer Aktivität erstellt, standardmäßig von der Kjuup-KI auf unseren eigenen Servern. Mit dieser Einstellung erstellt sie stattdessen ein Sprachmodell des externen KI-Anbieters Mistral AI SAS (Paris, Frankreich).',
            'Project reports show a project\'s current status and top priorities in its overview. They are written every night for projects with new activity, by default by the Kjuup AI on our own servers. With this setting, a language model of the external AI provider Mistral AI SAS (Paris, France) writes them instead.'),
        tr('project_report_notice_2',
            'Für die Erstellung übermittelt Kjuup die Inhalte des Projekts an Mistral: E-Mails, Chat- und Teams-Nachrichten, Aufgaben sowie Texte aus Anhängen. Diese Inhalte können personenbezogene Daten Dritter enthalten, etwa Namen und Kontaktdaten von Absendern.',
            'To write the report, Kjuup sends the project\'s content to Mistral: emails, chat and Teams messages, tasks, and text from attachments. This content may include personal data of third parties, such as names and contact details of senders.'),
        briefingInfoParagraphs[2],
        tr('project_report_notice_4',
            'Bitte aktivieren Sie diese Option nur, wenn Sie berechtigt sind, diese Inhalte an einen externen Dienstleister weiterzugeben – bei Firmenkonten in Abstimmung mit Ihrem Unternehmen. Sie können jederzeit zur Kjuup-KI zurückwechseln; ab dem nächsten Bericht werden dann keine Projektinhalte mehr an Mistral übermittelt.',
            'Please enable this option only if you are entitled to share this content with an external service provider – for company accounts, in agreement with your company. You can switch back to the Kjuup AI at any time; from the next report on, no project content is sent to Mistral.'),
    ];

    // Locked Kjuup.io rows stay readable at 45%; a click opens the Kjuup.io offer.
    const ioRow = (row) => (ioSettingsLocked
        ? {
            ...row,
            dimmed: true,
            busy: false,
            onClick: openCockpitIoOffer,
            toggle: row.toggle ? { ...row.toggle, disabled: false, onChange: () => openCockpitIoOffer() } : undefined,
        }
        : row);

    const openLanguageDialog = () => {
        setLangPick(currentLangCode || null);
        setLangQuery('');
        setDialog('language');
    };
    const confirmLanguage = () => {
        const next = langPick;
        setDialog(null);
        if (next && next !== currentLangCode) handleChangeLanguage(next);
    };
    const langNeedle = langQuery.trim().toLowerCase();
    const languageOptions = SUPPORTED_LANGUAGES.filter((lang) => !langNeedle
        || [lang.code, lang.name, lang.nativeName, lang.searchTerms].filter(Boolean).join(' ').toLowerCase().includes(langNeedle));

    const reportRows = showIoSettings ? [
        ioRow({
            key: 'report-time',
            icon: 'schedule',
            label: reportTimeLabel,
            value: formatBriefingHour(briefingHour),
            busy: briefingHourSaving,
            onClick: () => setDialog('report-time'),
        }),
        ioRow({
            key: 'report-model',
            icon: 'auto_awesome',
            label: briefingModelLabel,
            value: briefingModelName(briefingModel),
            busy: briefingModelSaving,
            onClick: () => setDialog('report-model'),
        }),
        ioRow({
            key: 'project-report',
            icon: 'summarize',
            label: projectReportLabel,
            sub: tr('project_report_info',
                'Der Stand in der Übersicht jedes Projekts wird nachts von der Kjuup-KI geschrieben. Eingeschaltet schreibt ihn Mistral AI.',
                'The status in each project\'s overview is written at night by the Kjuup AI. Switched on, Mistral AI writes it.'),
            toggle: {
                checked: projectReportModel === 'external',
                disabled: projectReportSaving,
                // Mistral needs the consent below; back to the Kjuup AI applies at once.
                onChange: () => (projectReportModel === 'external' ? _onChangeProjectReportModel('internal') : setDialog('project-report-info')),
            },
        }),
        ioRow({
            key: 'email-summary',
            icon: 'summarize',
            label: strings.email_summary_preview || tr('email_summary_preview', 'E-Mail-Zusammenfassung als Vorschau', 'Email summary as preview'),
            sub: strings.email_summary_preview_info || tr('email_summary_preview_info',
                'Wenn aktiviert, zeigt die Nachrichtenliste eine einzeilige Zusammenfassung jeder E-Mail. Wenn deaktiviert, wird der erste Satz der E-Mail angezeigt.',
                'When enabled, the message list shows a one-sentence summary of each email. When disabled, the first sentence of the email is shown.'),
            toggle: { checked: emailSummaryPreview, onChange: () => _onToggleEmailSummaryPreview(), disabled: emailSummaryPreviewSaving },
        }),
    ] : [];

    const accountRows = [
        { key: 'profile', icon: 'person', label: tr('pro_settings_profile', 'Profil', 'Profile'), onClick: () => history.push('/edit-profile') },
        {
            key: 'security',
            icon: 'shield_lock',
            label: tr('pro_settings_security', 'Sicherheit & Anmeldung in zwei Schritten', 'Security & 2-step login'),
            value: twoFactorOn == null ? undefined : (twoFactorOn ? onLabel : offLabel),
            onClick: () => openSectionView('twofa'),
        },
        {
            key: 'password',
            icon: 'key',
            label: strings.reset_password,
            onClick: () => {
                setPasswordParam({ password: '', confirmPassword: '' });
                setViewPassword(false);
                setViewPasswordConfirm(false);
                setDialog('password');
            },
        },
        user?.username ? {
            key: 'username',
            icon: 'alternate_email',
            label: strings.change_username,
            onClick: () => {
                setusername(user.username);
                setErrors((prev) => ({ ...prev, username: null }));
                setDialog('username');
            },
        } : null,
        user?.username ? {
            key: 'pin',
            icon: 'pin',
            label: strings.resetPIN,
            onClick: () => {
                setOtp('');
                setCOtp('');
                setIsInvalid(false);
                setInvalidMsg('');
                setDialog('pin');
            },
        } : null,
        isKjuupPlus ? {
            key: 'unavailability',
            icon: 'event_busy',
            label: tr('pro_settings_unavailability', 'Abwesenheit', 'Unavailability'),
            onClick: () => openSectionView('unavailability'),
        } : null,
    ];

    const companyRows = [
        {
            key: 'my-companies',
            icon: 'domain',
            label: tr('pro_settings_my_companies', 'Meine Firmen', 'My companies'),
            value: companyCount > 0 ? String(companyCount) : '',
            onClick: () => openMyCompanies(dispatch, history),
        },
        docsCompany ? {
            key: 'company-documents',
            icon: 'folder_shared',
            label: strings.company_documents || tr('company_documents', 'Firmendokumente', 'Company documents'),
            onClick: () => openCompanyDocuments(dispatch, history, docsCompany.id),
        } : null,
        adminCompany ? {
            key: 'admin-center',
            icon: 'settings',
            label: tr('cockpit_company_settings', 'Firmeneinstellungen', 'Company settings'),
            onClick: () => openCompanyAdmin(dispatch, history, adminCompany.id),
        } : null,
    ];

    const workspaceRows = isKjuupIoPackage ? [
        {
            key: 'chats',
            id: 'ps-row-chats',
            className: focusRow === 'chats' ? 'ps-row--focus' : '',
            icon: 'business_messages',
            label: strings.cockpit_toggle_chats || 'Kjuup-Chats',
            sub: strings.cockpit_toggle_chats_info || tr('cockpit_toggle_chats_info',
                'Kjuup-Chats in allen Bereichen ein- oder ausblenden. Beim Ausblenden werden die Mitglieder bestehender Chats darüber informiert, dass du über den Kjuup-Chat nicht mehr erreichbar bist.',
                'Show or hide Kjuup chats everywhere. When hidden, the members of your existing chats are told that you can no longer be reached via Kjuup chat.'),
            toggle: { checked: chatsEnabledPref, onChange: () => saveWorkspace({ chatsEnabled: !chatsEnabledPref }), disabled: workspaceSaving },
        },
        {
            key: 'email-client',
            icon: 'mail',
            label: strings.cockpit_toggle_email || tr('cockpit_toggle_email', 'E-Mail-Client', 'Email client'),
            sub: strings.cockpit_toggle_email_info || tr('cockpit_toggle_email_info', 'E-Mails direkt in Kjuup lesen und beantworten.', 'Read and reply to emails inside Kjuup.'),
            toggle: {
                checked: emailModePref !== 'reports',
                onChange: () => saveWorkspace({ emailMode: emailModePref === 'reports' ? 'client' : 'reports' }),
                disabled: workspaceSaving,
            },
        },
        // Microsoft Teams like the email client: off keeps the Teams chats for the daily report only.
        showTeamsSettings ? {
            key: 'teams-client',
            icon: 'groups',
            label: strings.cockpit_toggle_teams || 'Microsoft Teams',
            sub: strings.cockpit_toggle_teams_info || tr('cockpit_toggle_teams_info', 'Teams-Chats direkt in Kjuup lesen und beantworten.', 'Read and reply to Teams chats inside Kjuup.'),
            toggle: {
                checked: teamsModePref !== 'reports',
                onChange: () => saveWorkspace({ teamsMode: teamsModePref === 'reports' ? 'client' : 'reports' }),
                disabled: workspaceSaving,
            },
        } : null,
        ...reportRows,
    ] : [];

    const appRows = [
        { key: 'notifications', icon: 'notifications', label: strings.notification_settings, onClick: () => openSectionView('notifications') },
        { key: 'language', icon: 'language', label: strings.language, value: currentLang ? currentLang.nativeName : '', onClick: openLanguageDialog },
        {
            key: 'startup',
            icon: 'rocket_launch',
            label: strings.startup_screen_label || tr('startup_screen_label', 'Startbildschirm', 'Startup Screen'),
            value: startupLabel(startupOptions.find((s) => s.value === startupScreen) || startupOptions[0]),
            busy: startupScreenSaving,
            onClick: () => setDialog('startup'),
        },
        {
            key: 'translation',
            icon: 'translate',
            label: strings.auto_translation_languages_title || strings.auto_chat_translation,
            value: translationValue,
            busy: transLangSaving,
            onClick: () => setDialog('translation'),
        },
        {
            key: 'translate-names',
            icon: 'g_translate',
            label: strings.translate_room_group_names || tr('translate_room_group_names', 'Chatgruppennamen übersetzen', 'Translate chat group names'),
            sub: strings.translate_room_group_names_info || tr('translate_room_group_names_info',
                'Wenn aktiviert, werden Chatgruppennamen automatisch in deine Oberflächensprache übersetzt.',
                'When enabled, chat group names are automatically translated into your interface language.'),
            toggle: { checked: translateNames, onChange: () => _onToggleTranslateNames(), disabled: translateNamesSaving },
        },
        ...(isKjuupIoPackage ? [] : reportRows),
        showIoSettings ? ioRow({ key: 'email-accounts', icon: 'contact_mail', label: strings.email_accounts, onClick: () => openSectionView('email-accounts') }) : null,
        showIoSettings ? ioRow({
            key: 'email-forward',
            icon: 'forward_to_inbox',
            label: tr('email_forward_title', 'Weiterleitungsadresse', 'Forwarding address'),
            sub: tr('email_forward_row_sub', 'Reports ohne Postfach-Verbindung: E-Mails an eine Kjuup-Adresse weiterleiten', 'Reports without connecting a mailbox: forward emails to a Kjuup address'),
            onClick: () => openSectionView('email-forward'),
        }) : null,
        showCalendarSyncSettings ? ioRow({
            key: 'calendar-sync',
            icon: 'calendar_month',
            label: strings.calendar_sync_title || tr('calendar_sync_title', 'Kalender-Sync', 'Calendar Sync'),
            onClick: () => openSectionView('calendar-sync'),
        }) : null,
        showCalendarSyncSettings ? ioRow({
            key: 'todoist-sync',
            icon: 'checklist',
            label: strings.todoist_sync_title || 'Todoist',
            onClick: () => openSectionView('todoist-sync'),
        }) : null,
        showTeamsSettings ? {
            key: 'teams',
            icon: 'groups',
            label: strings.teams_title || 'Microsoft Teams',
            value: teamsRow?.connected && !ioSettingsLocked ? tr('v2_settings_connected', 'Verbunden', 'Connected') : undefined,
            dimmed: teamsRowLocked,
            onClick: teamsRowLocked ? openCockpitIoOffer : () => openSectionView('teams'),
        } : null,
        {
            key: 'recommend',
            icon: 'share',
            label: tr('recommend_kjuup', 'Kjuup weiterempfehlen', 'Recommend Kjuup'),
            onClick: () => recommendKjuup(strings, isGerm),
        },
    ];

    const endRows = [
        { key: 'logout', icon: 'logout', danger: true, label: tr('pro_settings_logout', 'Abmelden', 'Log out'), onClick: logout },
        { key: 'delete', icon: 'delete', danger: true, label: tr('pro_settings_delete_profile', 'Profil löschen', 'Delete profile'), onClick: () => deleteProfile() },
    ];

    const pickRows = (rows) => rows.filter(Boolean);
    const groups = [
        { key: 'account', caption: tr('v2_settings_account', 'Konto', 'Account'), rows: pickRows(accountRows) },
        { key: 'company', caption: tr('pro_settings_company', 'Firma', 'Company'), rows: pickRows(companyRows) },
        { key: 'workspace', caption: tr('v2_settings_workspace', 'Kjuup.io-Arbeitsbereich', 'Kjuup.io workspace'), rows: pickRows(workspaceRows) },
        { key: 'app', caption: tr('pro_settings_app', 'App', 'App'), rows: pickRows(appRows) },
        { key: 'end', caption: null, rows: pickRows(endRows) },
    ].filter((group) => group.rows.length);

    const sectionTitles = {
        notifications: strings.notification_settings,
        unavailability: strings.unavailability_note,
        twofa: strings.twofa_title || tr('twofa_title', 'Zwei-Faktor-Authentifizierung', 'Two-factor authentication'),
        'email-accounts': strings.email_accounts,
        'email-forward': tr('email_forward_title', 'Weiterleitungsadresse', 'Forwarding address'),
        'calendar-sync': strings.calendar_sync_title || tr('calendar_sync_title', 'Kalender-Sync', 'Calendar Sync'),
        'todoist-sync': strings.todoist_sync_title || 'Todoist',
        teams: strings.teams_title || 'Microsoft Teams',
    };

    // Booked packages are listed here only; the sidebar shows the offers.
    const bookedPackages = [
        isKjuupPlusMember
            ? { id: 'plus', label: 'Kjuup+', status: tr('products_kjuup_plus_sub_active', 'Aktiv über Firma', 'Active via company') }
            : null,
        stripeUiEnabled && subscriptionState.active
            ? {
                id: 'io',
                label: 'Kjuup.io',
                status: subscriptionState.trialing
                    ? tr('products_sub_trialing', 'Testphase aktiv', 'Trial active')
                    : tr('products_sub_active', 'Abo aktiv', 'Subscription active'),
            }
            : null,
    ].filter(Boolean);

    const planBody = (
        <>
            <span className="ps-plan-card__tile" aria-hidden="true">
                <span className="material-symbols-outlined">bolt</span>
            </span>
            <span className="ps-plan-card__text">
                <span className="ps-plan-card__title">{fillStr(tr('pro_settings_plan_title', 'Paket {{pkg}}', '{{pkg}} plan'), { pkg: packageLabel })}</span>
                <span className="ps-plan-card__sub">
                    {planClickable
                        ? tr('pro_settings_plan_sub', 'Pakete vergleichen und Plätze verwalten', 'Compare plans and manage seats')
                        : tr('pro_settings_plan_sub_static', 'Dein aktuelles Paket', 'Your current package')}
                </span>
                {bookedPackages.length ? (
                    <span className="ps-plan-card__booked">
                        {bookedPackages.map((pkg) => (
                            <span key={pkg.id} className={`ps-plan-card__abo ps-plan-card__abo--${pkg.id}`}>
                                <span className="material-symbols-outlined" aria-hidden="true">check_circle</span>
                                <span>
                                    <strong>{pkg.label}</strong> · {pkg.status}
                                </span>
                            </span>
                        ))}
                    </span>
                ) : null}
            </span>
        </>
    );

    const renderList = () => (
        <SettingsStack className="profile-setting__stack profile-setting__stack--list">
            <button type="button" className="ps-profile-card" onClick={() => history.push('/edit-profile')}>
                <SettingsAvatar src={avatarSrc} name={displayName} size="lg" ring />
                <span className="ps-profile-card__text">
                    <span className="ps-profile-card__name">{displayName}</span>
                    {profileSub ? <span className="ps-profile-card__sub">{profileSub}</span> : null}
                </span>
                <span className="material-symbols-outlined ps-card-chevron" aria-hidden="true">keyboard_arrow_right</span>
            </button>
            {planClickable ? (
                <button type="button" className="ps-plan-card" onClick={() => history.push('/subscription')}>
                    {planBody}
                    <span className="material-symbols-outlined ps-card-chevron ps-card-chevron--accent" aria-hidden="true">keyboard_arrow_right</span>
                </button>
            ) : (
                <div className="ps-plan-card">
                    {planBody}
                    <button
                        type="button"
                        className="kj-btn kj-btn--primary kj-btn--sm ps-plan-card__upgrade"
                        onClick={() => history.push({ pathname: "/", search: `?section=packages&focus=${Date.now()}` })}
                    >
                        {tr('pro_settings_plan_upgrade', 'Upgrade', 'Upgrade')}
                    </button>
                </div>
            )}
            {groups.map((group) => (
                <SettingsSection key={group.key} caption={group.caption}>
                    {group.rows.map(({ key, ...row }) => <SettingsRow key={key} {...row} />)}
                </SettingsSection>
            ))}
            <p className="ps-version">{`Kjuup ${version} · ${tr('pro_settings_made_in', 'Made in Germany', 'Made in Germany')}`}</p>
        </SettingsStack>
    );

    // ---- Abwesenheit (mobile UnavailabilityPro) ----
    const replacementColleague = unavailReplacementUser
        ? colleagues.find((c) => String(c.id) === String(unavailReplacementUser))
        : null;
    const replacementName = unavailReplacementUserName || (replacementColleague ? replacementColleague.name : '');
    const replacementNeedle = replacementQuery.trim().toLowerCase();
    const replacementOptions = colleagues.filter((c) => !replacementNeedle || String(c.name || '').toLowerCase().includes(replacementNeedle));
    const avatarUrl = (path) => (path ? `${BASE_URL}${path}` : '');

    const renderUnavailability = () => (
        <SettingsStack className="profile-setting__stack profile-setting__stack--section ps-unavail">
            <SettingsNote className="ps-intro">{strings.unavailability_description}</SettingsNote>
            {unavailLoading ? (
                <div className="kj-settings-card ps-skeleton" aria-busy="true">
                    {[0, 1, 2].map((i) => (
                        <div key={i} className="ps-skeleton__row">
                            <span className="ps-skeleton__tile" />
                            <span className={`ps-skeleton__line${i % 2 ? ' is-short' : ''}`} />
                        </div>
                    ))}
                </div>
            ) : (
                <>
                    {unavailActive ? (
                        <SettingsBanner
                            tone="warn"
                            icon="event_busy"
                            title={`${strings.unavailability_active_until}: ${formatDisplayDate(unavailEndDate) || '–'}`}
                        >
                            <button type="button" className="kj-btn kj-btn--secondary kj-btn--sm" onClick={handleUnavailDeactivate} disabled={unavailSaving}>
                                {strings.unavailability_deactivate}
                            </button>
                        </SettingsBanner>
                    ) : null}
                    <section className="kj-settings-section">
                        <h3 className="kj-settings-caption">{tr('pro_settings_unavail_period', 'Zeitraum', 'Period')}</h3>
                        <div className="ps-date-tiles">
                            <DateTile
                                id="ps-unavail-start"
                                icon="event"
                                label={strings.unavailability_start_date}
                                value={unavailStartDate}
                                onChange={setUnavailStartDate}
                            />
                            <DateTile
                                id="ps-unavail-end"
                                icon="event_busy"
                                label={`${strings.unavailability_end_date} *`}
                                value={unavailEndDate}
                                min={unavailStartDate}
                                onChange={setUnavailEndDate}
                            />
                        </div>
                    </section>
                    <div className="ps-field">
                        <label className="ps-field__label" htmlFor="ps-unavail-message">{strings.unavailability_message}</label>
                        <textarea
                            id="ps-unavail-message"
                            className="ps-textarea"
                            rows={5}
                            value={unavailMessage}
                            placeholder={strings.unavailability_default_message}
                            onChange={(e) => setUnavailMessage(e.target.value)}
                        />
                        <p className="ps-field__hint">{strings.unavailability_message_hint}</p>
                    </div>
                    <SettingsSection caption={strings.unavailability_replacement} note={strings.unavailability_replacement_hint}>
                        <SettingsRow
                            icon={replacementName ? undefined : 'person_add'}
                            leading={replacementName ? (
                                <SettingsAvatar src={avatarUrl(replacementColleague && replacementColleague.avatar)} name={replacementName} size="sm" />
                            ) : null}
                            label={replacementName || (colleaguesLoading
                                ? (strings.loading || tr('loading', 'Laden', 'Loading'))
                                : (strings.unavailability_replacement_none || tr('unavailability_replacement_none', 'Keine Vertretung (optional)', 'No replacement (optional)')))}
                            busy={colleaguesLoading}
                            onClick={colleaguesLoading ? undefined : () => { setReplacementQuery(''); setDialog('replacement'); }}
                        />
                    </SettingsSection>
                    <div className="ps-sticky-footer">
                        <button
                            type="button"
                            className={`kj-btn kj-btn--primary kj-btn--lg kj-btn--block${unavailSaving ? ' kj-btn--loading' : ''}`}
                            onClick={handleUnavailSave}
                            disabled={unavailSaving || unavailLoading}
                        >
                            {strings.unavailability_save}
                        </button>
                    </div>
                </>
            )}
        </SettingsStack>
    );

    const ioLocked = stripeUiEnabled && !hasActiveKjuupIoPlan;
    const renderSection = () => {
        switch (section) {
            case 'notifications':
                return (
                    <SettingsStack className="profile-setting__stack profile-setting__stack--section">
                        <NotificationSettings
                            todoNotificationEnabled={isTodoNotifOn}
                            onToggleTodoNotification={_onToggleTodoNotification}
                            emailPushNotificationEnabled={isEmailPushOn}
                            onToggleEmailPushNotification={_onToggleEmailPushNotification}
                            emailPushLocked={!isKjuupIoPackage}
                            emailSection={renderEmailNotifications()}
                        />
                    </SettingsStack>
                );
            case 'unavailability':
                return renderUnavailability();
            case 'twofa':
                return (
                    <SettingsStack className="profile-setting__stack profile-setting__stack--section">
                        <TwoFactorSettingsPanel strings={strings} onStatusChange={setTwoFactorOn} />
                    </SettingsStack>
                );
            case 'email-accounts':
                return (
                    <SettingsStack className="profile-setting__stack profile-setting__stack--section">
                        <div className="email-accounts-inner ps-email-accounts">
                            {renderEmailAccounts()}
                        </div>
                    </SettingsStack>
                );
            case 'email-forward':
                return (
                    <SettingsStack className="profile-setting__stack profile-setting__stack--section">
                        <EmailForwardSettings strings={strings} locked={ioLocked} />
                    </SettingsStack>
                );
            case 'calendar-sync':
                return (
                    <SettingsStack className="profile-setting__stack profile-setting__stack--section">
                        <CalendarSyncSettings strings={strings} locked={ioLocked} hasUsedTrial={hasUsedTrial} />
                    </SettingsStack>
                );
            case 'todoist-sync':
                return (
                    <SettingsStack className="profile-setting__stack profile-setting__stack--section">
                        <TodoistSyncSettings strings={strings} locked={ioLocked} />
                    </SettingsStack>
                );
            case 'teams':
                return (
                    <SettingsStack className="profile-setting__stack profile-setting__stack--section">
                        <TeamsSyncSettings strings={strings} locked={ioLocked} onRowState={setTeamsRow} />
                    </SettingsStack>
                );
            default:
                return null;
        }
    };

    const noResults = strings.no_search_result || strings.email_no_results || tr('pro_settings_no_results', 'Keine Ergebnisse', 'No results');

    return (
        <React.Fragment>
            <div className="company_section company_list setting_profile profile-setting">
                {viewLoader && (
                    <ApiLoaderOverlay text={strings.Loading} />
                )}
                {section ? (
                    <div className="page-header profile-setting__header">
                        <button
                            type="button"
                            className="kj-btn kj-btn--icon kj-btn--neutral profile-setting__back"
                            onClick={closeSectionView}
                            aria-label={strings.back || tr('back', 'Zurück', 'Back')}
                        >
                            <span className="material-symbols-outlined">keyboard_arrow_left</span>
                        </button>
                        <h2 className="page-header-title">{sectionTitles[section]}</h2>
                    </div>
                ) : null}
                <div className="profile-setting__body" ref={scrollRef}>
                    {section ? renderSection() : renderList()}
                </div>
            </div>

            <SettingsDialog
                show={dialog === 'language'}
                onHide={closeDialog}
                title={strings.change_language || tr('change_language', 'Sprache ändern', 'Change language')}
                closeLabel={strings.close}
                footer={(
                    <>
                        <button type="button" className="kj-btn kj-btn--secondary" onClick={closeDialog}>{strings.cancel}</button>
                        <button type="button" className="kj-btn kj-btn--primary" onClick={confirmLanguage} disabled={!langPick}>{strings.confirm}</button>
                    </>
                )}
            >
                <SearchField value={langQuery} onChange={setLangQuery} placeholder={strings.search} clearLabel={strings.cancel} autoFocus />
                <div className="ps-choice-list" role="radiogroup" aria-label={strings.language}>
                    {languageOptions.length ? languageOptions.map((lang) => (
                        <ChoiceRow
                            key={lang.code}
                            label={lang.nativeName}
                            sub={lang.code.toUpperCase()}
                            selected={langPick === lang.code}
                            onClick={() => setLangPick(lang.code)}
                            scrollIntoViewWhenSelected
                        />
                    )) : <p className="ps-choice-empty">{noResults}</p>}
                </div>
            </SettingsDialog>

            <SettingsDialog
                show={dialog === 'startup'}
                onHide={closeDialog}
                title={strings.startup_screen_label || tr('startup_screen_label', 'Startbildschirm', 'Startup Screen')}
                subtitle={strings.startup_screen_info || tr('startup_screen_info', 'Wähle, welcher Bildschirm beim Start von Kjuup geöffnet wird.', 'Choose which screen opens when you start Kjuup.')}
                closeLabel={strings.close}
            >
                <div className="ps-choice-list" role="radiogroup">
                    {startupOptions.map((s) => (
                        <ChoiceRow
                            key={s.value}
                            label={startupLabel(s)}
                            selected={startupScreen === s.value}
                            onClick={() => { setDialog(null); _onChangeStartupScreen(s.value); }}
                        />
                    ))}
                </div>
            </SettingsDialog>

            <SettingsDialog
                show={dialog === 'report-time'}
                onHide={closeDialog}
                title={reportTimeLabel}
                subtitle={strings.daily_briefing_hour_info || strings.daily_briefing_info || tr('daily_briefing_hour_info', 'Der Tagesbericht wird zu dieser Uhrzeit (Europe/Berlin) erstellt.', 'The daily report is created at this time (Europe/Berlin).')}
                closeLabel={strings.close}
            >
                <div className="ps-choice-list" role="radiogroup">
                    {BRIEFING_HOURS.map((hour) => (
                        <ChoiceRow
                            key={hour}
                            label={formatBriefingHour(hour)}
                            selected={briefingHour === hour}
                            onClick={() => { setDialog(null); _onChangeBriefingHour(hour); }}
                            scrollIntoViewWhenSelected
                        />
                    ))}
                </div>
            </SettingsDialog>

            <SettingsDialog
                show={dialog === 'report-model'}
                onHide={closeDialog}
                title={briefingModelLabel}
                subtitle={tr('daily_briefing_model_info', 'Gilt ab dem nächsten Tagesbericht.', 'Applies from the next daily report.')}
                closeLabel={strings.close}
            >
                <div className="ps-choice-list" role="radiogroup">
                    {BRIEFING_MODELS.map((mode) => (
                        <div className="ps-choice-row" key={mode}>
                            <ChoiceRow
                                label={briefingModelName(mode)}
                                sub={briefingModelHint(mode)}
                                selected={briefingModel === mode}
                                onClick={() => {
                                    if (mode === 'external' && briefingModel !== 'external') {
                                        setBriefingInfoConfirm(true);
                                        setDialog('report-model-info');
                                        return;
                                    }
                                    setDialog(null);
                                    _onChangeBriefingModel(mode);
                                }}
                            />
                            {mode === 'external' ? (
                                <button
                                    type="button"
                                    className="kj-btn kj-btn--icon kj-btn--neutral ps-choice-info"
                                    aria-label={briefingInfoTitle}
                                    title={briefingInfoTitle}
                                    onClick={() => { setBriefingInfoConfirm(false); setDialog('report-model-info'); }}
                                >
                                    <span className="material-symbols-outlined">info</span>
                                </button>
                            ) : null}
                        </div>
                    ))}
                </div>
            </SettingsDialog>

            <SettingsDialog
                show={dialog === 'report-model-info'}
                onHide={() => setDialog(briefingInfoConfirm ? 'report-model' : null)}
                title={briefingInfoTitle}
                closeLabel={strings.close}
                footer={briefingInfoConfirm ? (
                    <>
                        <button type="button" className="kj-btn kj-btn--secondary" onClick={() => setDialog('report-model')}>{strings.cancel}</button>
                        <button
                            type="button"
                            className="kj-btn kj-btn--primary"
                            onClick={() => { setDialog(null); _onChangeBriefingModel('external'); }}
                        >
                            {tr('daily_briefing_model_external_confirm', 'Zustimmen und aktivieren', 'Agree and enable')}
                        </button>
                    </>
                ) : (
                    <button type="button" className="kj-btn kj-btn--primary" onClick={() => setDialog('report-model')}>{strings.close}</button>
                )}
            >
                <div className="ps-info-text">
                    {briefingInfoParagraphs.map((text, i) => <p key={i}>{text}</p>)}
                </div>
            </SettingsDialog>

            <SettingsDialog
                show={dialog === 'project-report-info'}
                onHide={closeDialog}
                title={briefingInfoTitle}
                closeLabel={strings.close}
                footer={(
                    <>
                        <button type="button" className="kj-btn kj-btn--secondary" onClick={closeDialog}>{strings.cancel}</button>
                        <button
                            type="button"
                            className="kj-btn kj-btn--primary"
                            onClick={() => { setDialog(null); _onChangeProjectReportModel('external'); }}
                        >
                            {tr('daily_briefing_model_external_confirm', 'Zustimmen und aktivieren', 'Agree and enable')}
                        </button>
                    </>
                )}
            >
                <div className="ps-info-text">
                    {projectReportInfoParagraphs.map((text, i) => <p key={i}>{text}</p>)}
                </div>
            </SettingsDialog>

            <SettingsDialog
                show={dialog === 'translation'}
                onHide={closeDialog}
                title={strings.auto_translation_languages_title || strings.auto_chat_translation}
                subtitle={strings.auto_translation_languages_info || tr('auto_translation_languages_info',
                    'Wähle, welche Nachrichtensprachen automatisch in deine Oberflächensprache übersetzt werden sollen.',
                    'Select which message languages should be automatically translated into your interface language.')}
                closeLabel={strings.close}
                footer={(
                    <>
                        {transLangSaving ? <span className="ps-dialog__hint">{strings.saving || tr('saving', 'Speichern...', 'Saving...')}</span> : null}
                        <button type="button" className="kj-btn kj-btn--primary" onClick={closeDialog}>{strings.close}</button>
                    </>
                )}
            >
                <div className="ps-choice-list" role="group">
                    {TRANSLATION_LANGUAGES.map((lang) => (
                        <ChoiceRow
                            key={lang.code}
                            multi
                            label={lang.code === 'de' ? 'Deutsch (inkl. Schweizerdeutsch, Walliserdeutsch)' : lang.nativeName}
                            selected={autoTransLangSelection.includes(lang.code)}
                            onClick={() => toggleAutoTransLang(lang.code)}
                        />
                    ))}
                </div>
            </SettingsDialog>

            <SettingsDialog show={dialog === 'password'} onHide={closeDialog} title={strings.reset_password} closeLabel={strings.close}>
                <form className="ps-form" onSubmit={(e) => { e.preventDefault(); resetPassword(); }}>
                    <PasswordField
                        id="ps-new-password"
                        label={`${strings.password}*`}
                        value={passwordParam.password}
                        onChange={(value) => setPasswordParams('password', value)}
                        visible={viewPassword}
                        onToggle={() => setViewPassword(!viewPassword)}
                        toggleLabel={strings.password}
                    />
                    <PasswordField
                        id="ps-confirm-password"
                        label={`${strings.confirm_password}*`}
                        value={passwordParam.confirmPassword}
                        onChange={(value) => setPasswordParams('confirmPassword', value)}
                        visible={viewPasswordConfirm}
                        onToggle={() => setViewPasswordConfirm(!viewPasswordConfirm)}
                        toggleLabel={strings.confirm_password}
                    />
                    <p className="ps-field__hint">{strings.pass_minimum?.replace("**", "*")}</p>
                    <button type="submit" className="kj-btn kj-btn--primary kj-btn--lg kj-btn--block">
                        {strings.submit || strings.update}
                    </button>
                </form>
            </SettingsDialog>

            <SettingsDialog show={dialog === 'username'} onHide={closeDialog} title={strings.change_username} closeLabel={strings.close}>
                <form className="ps-form" onSubmit={(e) => { e.preventDefault(); if (!errors.username) resetUserName(); }}>
                    <div className="ps-field">
                        <label className="ps-field__label" htmlFor="ps-username">{strings.username}</label>
                        <div className="ps-input">
                            <span className="material-symbols-outlined" aria-hidden="true">alternate_email</span>
                            <input
                                id="ps-username"
                                type="text"
                                autoComplete="off"
                                value={username || ''}
                                onChange={(event) => {
                                    // An e-mail address can't be a username (mobile: prevent_email).
                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    if (emailRegex.test(event.target.value)) {
                                        setErrors({ ...errors, username: strings.prevent_email });
                                        event.preventDefault();
                                    } else {
                                        setErrors({ ...errors, username: null });
                                        setusername(event.target.value);
                                    }
                                }}
                            />
                        </div>
                        {errors.username ? <p className="ps-field__error">{errors.username}</p> : null}
                    </div>
                    <button type="submit" className="kj-btn kj-btn--primary kj-btn--lg kj-btn--block" disabled={!!errors.username}>
                        {strings.submit || strings.update}
                    </button>
                </form>
            </SettingsDialog>

            <SettingsDialog show={dialog === 'pin'} onHide={closeDialog} title={strings.resetPIN} closeLabel={strings.close}>
                <div className="ps-form ps-pin">
                    <p className="ps-field__label">{strings.enter_current_pin}</p>
                    <OtpInput
                        value={otp}
                        onChange={handlePinChange}
                        numInputs={6}
                        isInputNum
                        shouldAutoFocus
                        separator={<span className="profile-setting__pin-sep" />}
                        containerStyle="ps-otp"
                        inputStyle="ps-otp__input"
                        focusStyle="ps-otp__input--focus"
                    />
                    <p className="ps-field__label ps-pin__label--spaced">{strings.enter_new}</p>
                    <OtpInput
                        value={cotp}
                        onChange={handlePinChangeC}
                        numInputs={6}
                        isInputNum
                        separator={<span className="profile-setting__pin-sep" />}
                        containerStyle="ps-otp"
                        inputStyle="ps-otp__input"
                        focusStyle="ps-otp__input--focus"
                    />
                    {isInvalid ? <p className="ps-field__error">{invalidMsg}</p> : null}
                    <button
                        type="button"
                        className="kj-btn kj-btn--primary kj-btn--lg kj-btn--block"
                        disabled={pinLoading || otp.length !== 6 || cotp.length !== 6}
                        onClick={handlePinReset}
                    >
                        {pinLoading ? <LoadingDots /> : strings.confirm}
                    </button>
                </div>
            </SettingsDialog>

            <SettingsDialog show={dialog === 'replacement'} onHide={closeDialog} title={strings.unavailability_replacement} closeLabel={strings.close}>
                <SearchField value={replacementQuery} onChange={setReplacementQuery} placeholder={strings.search} clearLabel={strings.cancel} autoFocus />
                <div className="ps-choice-list" role="radiogroup">
                    <ChoiceRow
                        leading={(
                            <span className="ps-none-mark" aria-hidden="true">
                                <span className="material-symbols-outlined">person_off</span>
                            </span>
                        )}
                        label={strings.unavailability_replacement_none || tr('unavailability_replacement_none', 'Keine Vertretung (optional)', 'No replacement (optional)')}
                        selected={!unavailReplacementUser}
                        onClick={() => { setUnavailReplacementUser(''); setUnavailReplacementUserName(''); setDialog(null); }}
                    />
                    {replacementOptions.map((c) => (
                        <ChoiceRow
                            key={c.id}
                            leading={<SettingsAvatar src={avatarUrl(c.avatar)} name={c.name} />}
                            label={c.name}
                            selected={String(c.id) === String(unavailReplacementUser)}
                            onClick={() => { setUnavailReplacementUser(c.id); setUnavailReplacementUserName(c.name); setDialog(null); }}
                        />
                    ))}
                    {!replacementOptions.length ? <p className="ps-choice-empty">{strings.no_data || noResults}</p> : null}
                </div>
            </SettingsDialog>

            {renderEmailModals()}
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    const { language } = state;
    return {
        language: language,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        toggleLanguage: value => dispatch({ type: LANGUAGE, language: value }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProfileSetting));

